import React from 'react';

interface BulldozerSelectedProps {
  height?: number;
  width?: number;
}

const BulldozerSelected: React.FC<BulldozerSelectedProps> = ({
  height = 96.483,
  width = 186.099,
}) => {
  return (
    <svg
      viewBox="0 0 186.099 96.483"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#808080"
      height={height}
      width={width}
    >
      <defs>
        <filter
          id="Path_21043"
          x="0"
          y="46.825"
          width="139.461"
          height="49.658"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feFlood />
          <feComposite operator="in" in2="blur" />
          <feComposite in="SourceGraphic" />
        </filter>
      </defs>
      <g id="Group_58624" data-name="Group 58624" transform="translate(9)">
        <path
          id="Path_21023"
          data-name="Path 21023"
          d="M97.071,32.938h-1.55v1.7h-.774v-1.7H93.2v1.7h-.776v-1.7H90.958V27.481H93.5a31.559,31.559,0,0,0-.1-4.111c-.23-1.657-2.488-2.141-2.488-2.141.045-.488.081-.987.081-1.394a5.4,5.4,0,0,0-.459-1.717,28.587,28.587,0,0,1,4.352,2.462c.781.726.459.5,1.126,1.7v5.2h1.162v7.156h-.1Z"
          transform="translate(8.342 -3.792)"
          fill="#5f6061"
        />
        <path
          id="Path_21024"
          data-name="Path 21024"
          d="M87.452,40.5V36.859h1.614v1.7h.777v-1.7h1.551v1.7h.775v-1.7h1.548v1.7h.776v-1.7h1.551v1.7h.777v-1.7h1.548v1.7h.776v-1.7h1.55v1.7h.777v-1.7h1.547v1.7h.777v-1.7h1.551v1.7h.773v-1.7h1.551v1.7h.776v-1.7H110v1.7h.774v-1.7h1.55v1.7h.776v-1.7h1.756V40.5Z"
          transform="translate(-6.906 -7.714)"
          fill="#db9e00"
        />
        <path
          id="Path_21025"
          data-name="Path 21025"
          d="M183.6,37.7l.334-2.379s14.743-24.4,15.431-25.134c.52-.55,2.547-.338,3.505-.2l-16.316,28Z"
          transform="translate(-170.956 -2.058)"
          fill="#f2f2f2"
        />
        <path
          id="Path_21026"
          data-name="Path 21026"
          d="M117.812,52.605a3.909,3.909,0,0,1-.166,1.092c-.175.479-.367.733-.761.737h-33.6c-.4,0-.592-.259-.767-.737a3.91,3.91,0,0,1-.166-1.092h0l0-11.144h35.338l.122.214v10.9c0-.036,0-.008,0,.025"
          transform="translate(-5.838 -8.675)"
          fill="#ffb800"
        />
        <path
          id="Path_21027"
          data-name="Path 21027"
          d="M193.836,64.108l.017,2.675c-.521.195-.883.5-.92.946l-.021.257q-1.977-.094-3.967-.149l0-.2c-.018-1.885-6.159-1.866-6.139.065v.055q-2.01,0-4.017.033l-.008-.207c-.055-1.884-6.195-1.744-6.136.187l.006.2q-2.238.087-4.448.2l0-.084c-.1-1.882-6.234-1.608-6.132.321l.006.145q-1.975.14-3.9.3c-.164-1.858-6.246-1.509-6.124.413l.008.128c-.595.056-1.181.114-1.766.172a4.192,4.192,0,0,0-2.145-.26c-.72-1.554-6.236-.845-6.015.981l.017.149c-3.034.346-5.849.686-8.365.992a4.368,4.368,0,0,0-1.457.419,12.268,12.268,0,0,0-2.8,1.02.157.157,0,0,0-.014.018c-.151.029-.3.066-.444.1l-.871-2.137,0-.011.545-.2,16.953-6.221Z"
          transform="translate(-118.118 -13.415)"
          fill="#c28c00"
        />
        <path
          id="Path_21028"
          data-name="Path 21028"
          d="M70.549,43.318l.933.062,1.391,1.391-1.8-.122Z"
          transform="translate(48.438 -9.065)"
          fill="#db9e00"
        />
        <path
          id="Path_21029"
          data-name="Path 21029"
          d="M116.915,43.833l.033.424-.356-.1v8.451h0a4.744,4.744,0,0,1-.211,1.378,1.749,1.749,0,0,1-1.626,1.363h-33.6a1.757,1.757,0,0,1-1.635-1.363,4.833,4.833,0,0,1-.211-1.378c0-.032,0-.061,0-.025V41.461h.909l0,11.144h0a3.9,3.9,0,0,0,.165,1.092c.175.478.368.733.767.738h33.6c.395,0,.587-.259.761-.738a3.876,3.876,0,0,0,.166-1.092c0-.032,0-.061,0-.025V41.587l.909.935.969.065.527,1.326Z"
          transform="translate(-3.705 -8.675)"
          fill="#db9e00"
        />
        <path
          id="Path_21030"
          data-name="Path 21030"
          d="M142.477,9.108l-.615-.225-4.167.867,12.574-2.622c0,.976,7.379,15.277,11.169,22.557h-18.96Z"
          transform="translate(-93.222 -1.492)"
          fill="#f2f2f2"
        />
        <path
          id="Path_21031"
          data-name="Path 21031"
          d="M175.85,34.646h-3.995V12.092l8.126-1.311-4.131,1.311Z"
          transform="translate(-138.779 -2.256)"
          fill="#d6d6d6"
        />
        <path
          id="Path_21032"
          data-name="Path 21032"
          d="M171.855,12.092l4.131-1.311V34.646h-4.131Z"
          transform="translate(-134.784 -2.256)"
          fill="#f2f2f2"
        />
        <path
          id="Path_21033"
          data-name="Path 21033"
          d="M134.923,10.215l4.167-.867.616.225V30.151h18.963c1.307,2.518,2.188,4.2,2.188,4.2H134.923Z"
          transform="translate(-90.451 -1.956)"
          fill="#d4d4d4"
        />
        <path
          id="Path_21034"
          data-name="Path 21034"
          d="M131.893,44.21h39.693l.649,12.669-36.215-.252ZM138,46.893c0-.728-.466-.637-.466-.637H134.42c-.66,0-.469,1.546-.469,1.546h3.917a1.769,1.769,0,0,0,.136-.909"
          transform="translate(-99.433 -9.251)"
          fill="#db9e00"
        />
        <path
          id="Path_21035"
          data-name="Path 21035"
          d="M175.675,46.8h3.119s.466-.093.466.637a1.769,1.769,0,0,1-.136.909h-3.917s-.192-1.546.468-1.546"
          transform="translate(-140.688 -9.791)"
          fill="#ffb800"
        />
        <path
          id="Path_21036"
          data-name="Path 21036"
          d="M212.875,62.5H210.45l-8.993-.3-1.92-.063a9.938,9.938,0,0,1-1-2.709c0-.785,2.624-1.29,2.624-1.29l-.709,1.472h13.274Z"
          transform="translate(-193.627 -12.166)"
          fill="#5f6061"
        />
        <path
          id="Path_21037"
          data-name="Path 21037"
          d="M208.7,53.674l-4.993.652.574-1.606,3.5-.422,2.174-6.07-3.3-.351v-.112l.684.079,3.8.439Z"
          transform="translate(-195.124 -9.575)"
          fill="#db9e00"
        />
        <path
          id="Path_21038"
          data-name="Path 21038"
          d="M211.81,46.238l-2.174,6.07-3.5.422-.27.032-.66.079,2.622-6.773v-.255l.682.073Z"
          transform="translate(-196.981 -9.587)"
          fill="#ec1c24"
        />
        <path
          id="Path_21039"
          data-name="Path 21039"
          d="M76.689,41.529,76.163,40.2l-3.343-8.42,4.315-1.713,4.159,10.476.529,1.332Z"
          transform="translate(37.692 -6.293)"
          fill="#3b3c3d"
        />
        <path
          id="Path_21040"
          data-name="Path 21040"
          d="M68.891,66.561l-.029-.073-.455-1.147-.682.27-1.279-3.221.682-.27-3.7-9.329,4.989-.011,3.029,7.629.682-.27L73.4,63.361l-.681.27L73.2,64.85l-.918.364-2.478.984Z"
          transform="translate(53.544 -11.045)"
          fill="#3b3c3d"
        />
        <path
          id="Path_21041"
          data-name="Path 21041"
          d="M57.7,84.653l2.478-.984.514-.2.82,2.066H57.357l-.254-.642Z"
          transform="translate(70.432 -17.465)"
          fill="#3b3c3d"
        />
        <path
          id="Path_21042"
          data-name="Path 21042"
          d="M176.283,41.883l3.7,9.329-.682.271,1.279,3.22.682-.27.455,1.147L177.9,60.369c-.833-.712-1.686-1.125-2.117-.733-.224.2-.48.44-.735.677a11.3,11.3,0,0,0-4.061-.924,3.768,3.768,0,0,0-.4-.074l.108.013.035-.293c.224-1.873-5.869-2.644-6.1-.728l-.012.107c-1.3-.192-2.7-.4-4.09-.6l.025-.224c.223-1.872-5.868-2.643-6.1-.725l-.007.062-3.891-.565-.2-.03.021-.186c.224-1.872-5.868-2.643-6.1-.728l-.01.087q-2.007-.225-4.048-.4l.012-.15c.119-1.446-3.463-2.1-5.2-1.451l-.017-2.675-48.153.306L69.926,57.357l-2.781-7.184,8.993.3h2.424l.854-2.886H66.142L68.2,43.311l.27-.032L67.9,44.885l4.993-.652,2.443-7.392-3.8-.439.306-.635.124.012,2.956.282,16.315-28,.924-1.585L117.22.644,119.6,5.463l-.166.425s.156.017.394.037l13.319,27h1.779V44.04c0-.036,0-.008,0,.025a4.874,4.874,0,0,0,.212,1.378,1.756,1.756,0,0,0,1.635,1.363h33.6a1.749,1.749,0,0,0,1.626-1.363,4.743,4.743,0,0,0,.211-1.378h0V35.614l.355.1-.032-.425,1.173.08,5.132.349,1.8.123,3.485,6.023-2.838.006ZM100.516,8.66,92.391,9.971V32.525h8.126Zm27.016,19.669h0c-3.79-7.28-11.169-21.581-11.169-22.557L103.787,8.394V32.525h25.934s-.881-1.678-2.188-4.2m3.935,6.765H91.775L95.9,47.511l36.214.252Zm46.85,5.062a1.565,1.565,0,1,0-1.565-1.565,1.565,1.565,0,0,0,1.565,1.565"
          transform="translate(-59.314 -0.136)"
          fill="#ffb800"
        />
        <g transform="matrix(1, 0, 0, 1, -9, 0)" filter="url(#Path_21043)">
          <path
            id="Path_21043-2"
            data-name="Path 21043"
            d="M71.434,81.756c.523-.011,1.17-.018,1.726-.023A12.992,12.992,0,0,1,74.486,78.6c-.291-.273-.561-.53-.716-.7-.974-1.054,3-5.443,4.118-4.424.305.278.665.612,1,.927a10.605,10.605,0,0,1,2.409-.859c.148-.034.293-.071.444-.1a.158.158,0,0,1,.015-.017,12.276,12.276,0,0,1,2.8-1.021,4.363,4.363,0,0,1,1.456-.419c2.517-.307,5.331-.647,8.365-.992l-.017-.149c-.221-1.826,5.294-2.534,6.015-.981a4.184,4.184,0,0,1,2.145.261c.584-.058,1.17-.115,1.765-.172l-.007-.128c-.123-1.921,5.959-2.269,6.123-.412q1.929-.157,3.9-.3l-.006-.145c-.1-1.929,6.034-2.2,6.132-.322l0,.084q2.207-.117,4.448-.2l-.007-.2c-.058-1.929,6.082-2.07,6.137-.186l.007.206q2.006-.034,4.018-.033v-.055c-.02-1.931,6.121-1.949,6.139-.064l0,.2q1.99.055,3.967.15l.021-.258c.037-.444.4-.75.92-.945,1.736-.648,5.318.006,5.2,1.451l-.011.15q2.04.172,4.047.4l.01-.087c.228-1.915,6.32-1.144,6.1.728l-.021.186.2.03,3.891.565.007-.062c.229-1.918,6.321-1.147,6.1.725l-.025.224c1.393.2,2.789.409,4.09.6l.013-.108c.228-1.917,6.321-1.144,6.1.727l-.035.294-.108-.013c.248.041.4.067.4.073a11.32,11.32,0,0,1,4.061.924c.255-.236.512-.472.735-.677.43-.392,1.284.021,2.116.733a8.253,8.253,0,0,1,.691.666l-3.967,1.762c-.11-.168-.242-.251-.4-.19l-.287.109a10.328,10.328,0,0,0-5.381-1.4s-21.011-3.407-28.07-4.095c-6.615-.644-17.946-.883-26.573-.8-10.107.1-28.964,2.6-40.131,4.895-12.73,2.619-13.7,19.374,0,20.168,7.186.415,44.008.5,58.675.461,14.665.043,28.913-.046,36.1-.461a13.372,13.372,0,0,0,1.587-.2,1.4,1.4,0,0,1-.563-.43,2.043,2.043,0,0,0-1.838,0,1.379,1.379,0,1,1,0-1.665,2.07,2.07,0,0,0,1.838,0,1.372,1.372,0,1,1,2.153,1.7,9.677,9.677,0,0,0,4.715-3.265l3.928.016c-.044.083-.08.169-.125.251.149.142.283.275.373.373.974,1.054-3,5.444-4.117,4.426-.2-.181-.42-.384-.641-.589a12.006,12.006,0,0,1-4.873,1.192c0,.074,0,.151,0,.221-.014,1.511-5.936,1.43-6.043,0-.006-.054-.007-.128-.009-.2q-2.136,0-4.162,0c0,.066,0,.139,0,.2-.014,1.511-5.937,1.43-6.045,0,0-.056-.007-.136-.009-.207q-2.152,0-4.159,0c0,.07,0,.143,0,.21-.013,1.511-5.937,1.43-6.045,0,0-.059-.006-.137-.009-.213h-4.159c0,.07,0,.145,0,.213-.013,1.511-5.936,1.43-6.043,0,0-.057-.007-.136-.009-.21q-2.294,0-4.16,0c0,.07,0,.141,0,.206-.014,1.511-5.936,1.43-6.044,0-.006-.053-.008-.127-.01-.2l-2.369.008-1.792-.006c0,.063,0,.133,0,.193-.013,1.511-5.935,1.43-6.043,0-.006-.056-.007-.133-.009-.2-1.236,0-2.625,0-4.16-.006,0,.07,0,.144,0,.21-.014,1.511-5.937,1.43-6.044,0,0-.059-.008-.137-.009-.213h-4.159c0,.07,0,.145,0,.213-.014,1.511-5.937,1.43-6.045,0,0-.057-.008-.137-.01-.21q-2.007,0-4.159,0c0,.068,0,.142,0,.207-.013,1.511-5.935,1.43-6.043,0,0-.055-.008-.133-.01-.2-1.353,0-2.733,0-4.16,0,0,.065,0,.136,0,.2-.014,1.511-5.937,1.43-6.045,0,0-.053-.006-.127-.009-.193a11.992,11.992,0,0,1-5.948-1.48c-.314.291-.639.593-.92.848-1.117,1.018-5.09-3.372-4.118-4.426.187-.2.535-.531.9-.866a12.422,12.422,0,0,1-1.1-3.435c-.531.009-1.058.009-1.352-.009-1.431-.093-1.57-6.015-.059-6.044m106.26,11.17a.943.943,0,1,0,.943.94.943.943,0,0,0-.943-.94m4.021,0a.943.943,0,1,0,.943.94.942.942,0,0,0-.943-.94"
            transform="translate(-61.36 -13.98)"
            fill="#505152"
          />
        </g>
        <path
          id="Path_21044"
          data-name="Path 21044"
          d="M69.282,85.455l-.8-.423a10.064,10.064,0,0,0-1.122-2.463l2.788-1.238a12.85,12.85,0,0,1,1.534,3.45c.331,0,.661.007.949.015.438.008.733.519.9,1.231l-3.194-.006-1.06-.565Z"
          transform="translate(50.292 -17.019)"
          fill="#505152"
        />
        <path
          id="Path_21045"
          data-name="Path 21045"
          d="M182.794,77a1.369,1.369,0,0,0-1.152.4,5.145,5.145,0,0,1-.939.1,5.073,5.073,0,0,1-.883-.331,1.378,1.378,0,1,0-.212,1.652,2.053,2.053,0,0,1,1.823.233c.018.032.043.058.064.088l-.837.316H166.769c-1.423,0-1.376,1.665-1.376,1.665v1.94H126.849l.43.705-.013,6.659H126.21l.319-7.364H96.42v7.447h1.71l.047.042a.6.6,0,0,0,0,.066.655.655,0,0,0,0,.068c-.146.119-.337.3-.337.414a2.392,2.392,0,0,0,.055.288,2.277,2.277,0,0,0,.075.281c.051.105.3.183.482.226.017.043.038.083.059.124-.079.171-.175.414-.124.518a2.606,2.606,0,0,0,.174.233,2.733,2.733,0,0,0,.191.224c.091.071.345.034.531-.006.035.029.071.057.108.085a1.767,1.767,0,0,0,.033.342c-.035,0-.068-.01-.1-.01a1.37,1.37,0,0,0-1.094.546,5.247,5.247,0,0,1-.918.215,5.255,5.255,0,0,1-.919-.215,1.377,1.377,0,1,0,0,1.665,5.014,5.014,0,0,1,.919-.219,5.006,5.006,0,0,1,.918.219,1.374,1.374,0,1,0,2.032-1.835,2.185,2.185,0,0,0,.249-.169c.043.01.086.025.134.034.084.168.214.392.327.417a2.239,2.239,0,0,0,.292.011,2.442,2.442,0,0,0,.293-.011c.111-.025.24-.248.325-.417.045-.009.09-.024.134-.034.02.016.043.032.066.048a1.375,1.375,0,1,0,1.885,1.956,5.029,5.029,0,0,1,.919-.219,5.036,5.036,0,0,1,.92.219,1.379,1.379,0,1,0,0-1.665,5.278,5.278,0,0,1-.92.215,5.271,5.271,0,0,1-.919-.215,1.374,1.374,0,0,0-.871-.52,1.845,1.845,0,0,0,.038-.357l.108-.082c.184.038.441.075.529,0a2.129,2.129,0,0,0,.191-.221,2.43,2.43,0,0,0,.176-.236c.05-.1-.044-.346-.123-.518.02-.041.038-.081.058-.124.182-.043.432-.121.482-.224a2.352,2.352,0,0,0,.074-.283,2.392,2.392,0,0,0,.055-.288c0-.116-.19-.294-.337-.414,0-.023,0-.043,0-.068s0-.043,0-.066c.016-.013.032-.028.048-.042h8.152l.047.042c0,.022,0,.044,0,.066s0,.045,0,.068c-.145.119-.335.3-.335.414a2.6,2.6,0,0,0,.053.288,2.329,2.329,0,0,0,.078.281c.049.105.3.183.482.226.017.043.038.083.058.124-.079.171-.174.414-.123.518a2.288,2.288,0,0,0,.173.233,2.422,2.422,0,0,0,.191.224c.09.071.344.034.531-.006.035.029.072.057.108.085a1.155,1.155,0,0,0,.078.467,1.4,1.4,0,0,0-.508.41,5.271,5.271,0,0,1-.919.215,5.247,5.247,0,0,1-.918-.215,1.377,1.377,0,1,0,0,1.665,5.007,5.007,0,0,1,.918-.219,5.029,5.029,0,0,1,.919.219,1.373,1.373,0,0,0,2.267-1.544h.033a2.4,2.4,0,0,0,.292-.011c.112-.025.242-.248.326-.417.045-.009.09-.024.134-.034.149.116.365.263.477.236a1.349,1.349,0,0,0,.193-.081,1.373,1.373,0,1,0,2.014,1.85,5.036,5.036,0,0,1,.92-.219,5.044,5.044,0,0,1,.919.219,1.379,1.379,0,1,0,0-1.665,5.287,5.287,0,0,1-.919.215,5.278,5.278,0,0,1-.92-.215,1.369,1.369,0,0,0-1.091-.546,1.385,1.385,0,0,0-.535.108,1.384,1.384,0,0,0,.059-.439l.108-.082c.184.038.44.075.53,0a2.162,2.162,0,0,0,.19-.221,2.308,2.308,0,0,0,.176-.236c.05-.1-.043-.346-.123-.518.021-.041.039-.081.058-.124.183-.043.433-.121.483-.224a2.359,2.359,0,0,0,.074-.283,2.511,2.511,0,0,0,.055-.288c0-.116-.19-.294-.336-.414,0-.023,0-.043,0-.068s0-.043,0-.066c.016-.013.032-.028.048-.042h8.152c.017.014.032.029.048.042,0,.022,0,.044,0,.066s0,.045,0,.068c-.146.119-.336.3-.336.414a2.6,2.6,0,0,0,.053.288,2.192,2.192,0,0,0,.077.281c.047.1.278.177.46.221v.249h.028a.633.633,0,0,0-.072.4,2.236,2.236,0,0,0,.175.233,2.327,2.327,0,0,0,.191.224c.089.071.344.034.53-.006.034.029.072.057.109.085,0,.19.022.448.111.521a2.807,2.807,0,0,0,.259.136l.1.046a1.448,1.448,0,0,0-.166.175,5.3,5.3,0,0,1-.92.215,5.247,5.247,0,0,1-.918-.215,1.377,1.377,0,1,0,0,1.665,5.006,5.006,0,0,1,.918-.219,5.051,5.051,0,0,1,.92.219,1.374,1.374,0,1,0,2.082-1.786c.038-.062.074-.126.1-.184.044-.009.091-.024.134-.034.149.116.365.263.476.236a2.093,2.093,0,0,0,.27-.117,2.872,2.872,0,0,0,.259-.136c.089-.073.11-.331.111-.521l.111-.082c.183.038.44.075.528,0a2.051,2.051,0,0,0,.191-.221,2.576,2.576,0,0,0,.176-.236.594.594,0,0,0-.062-.376l8.781.036a.531.531,0,0,0-.05.341,2.456,2.456,0,0,0,.174.233,2.2,2.2,0,0,0,.191.224c.09.071.344.034.53-.006.035.029.071.057.109.085,0,.19.021.448.112.521a2.564,2.564,0,0,0,.259.136,2.007,2.007,0,0,0,.268.117c.111.026.327-.12.478-.236.043.01.087.025.134.034.009.018.021.039.031.059a1.393,1.393,0,0,0-.249.248,5.247,5.247,0,0,1-.918.215,5.238,5.238,0,0,1-.919-.215,1.377,1.377,0,1,0,0,1.665,2.035,2.035,0,0,1,1.837,0,1.374,1.374,0,1,0,2.09-1.778c.052-.017.153-.064.244-.108a2.872,2.872,0,0,0,.259-.136c.089-.073.11-.331.112-.521l.109-.082c.183.038.44.075.529,0a2.23,2.23,0,0,0,.191-.221,2.869,2.869,0,0,0,.175-.236.5.5,0,0,0-.044-.318l8.743.035a.444.444,0,0,0-.031.283,2.657,2.657,0,0,0,.175.233,2.306,2.306,0,0,0,.191.224c.089.071.343.034.531-.006.034.029.07.057.108.085,0,.19.021.448.113.521a2.451,2.451,0,0,0,.258.136,2,2,0,0,0,.268.117c.112.026.328-.12.477-.236.046.01.089.025.137.034a1.2,1.2,0,0,0,.259.378,5.569,5.569,0,0,1-.662.143,5.222,5.222,0,0,1-.919-.215,1.377,1.377,0,1,0,0,1.665,4.984,4.984,0,0,1,.919-.219,5.044,5.044,0,0,1,.919.219,1.374,1.374,0,1,0,1.819-2l.039-.022c.091-.073.111-.331.113-.521l.109-.082c.183.038.44.075.528,0a2.032,2.032,0,0,0,.191-.221,2.921,2.921,0,0,0,.176-.236.412.412,0,0,0-.024-.26l3.712.015a1.265,1.265,0,0,0,1.283,1.031h19.646a1.243,1.243,0,0,0,1.257-.943l.742,0a9.671,9.671,0,0,1-4.715,3.264,1.371,1.371,0,1,0-2.153-1.7,2.07,2.07,0,0,1-1.838,0,1.377,1.377,0,1,0,0,1.665,2.037,2.037,0,0,1,1.838,0,1.393,1.393,0,0,0,.563.429,13.358,13.358,0,0,1-1.588.2c-7.186.414-21.433.5-36.1.461-14.667.043-51.489-.047-58.675-.461-13.7-.795-12.729-17.549,0-20.168,11.168-2.3,30.025-4.8,40.132-4.895,8.627-.084,19.957.156,26.573.8,7.058.687,28.069,4.1,28.069,4.1a10.321,10.321,0,0,1,5.382,1.4l-1.92.729a1.375,1.375,0,0,0-1.187-1.2M171.04,96.157a1.379,1.379,0,0,0,1.092-.545,2.037,2.037,0,0,1,1.838,0,1.379,1.379,0,1,0,0-1.665,2.07,2.07,0,0,1-1.838,0,1.376,1.376,0,1,0-1.092,2.209m-7.574,0a1.379,1.379,0,0,0,1.092-.545,2.037,2.037,0,0,1,1.838,0,1.379,1.379,0,1,0,0-1.665,2.07,2.07,0,0,1-1.838,0,1.376,1.376,0,1,0-1.092,2.209m-15.149,0a1.381,1.381,0,0,0,1.093-.545,4.983,4.983,0,0,1,.919-.219,5.044,5.044,0,0,1,.919.219,1.379,1.379,0,1,0,0-1.665,5.287,5.287,0,0,1-.919.215,5.222,5.222,0,0,1-.919-.215,1.376,1.376,0,1,0-1.093,2.209m-15.148,0a1.377,1.377,0,0,0,1.091-.545,5.021,5.021,0,0,1,.92-.219,5.013,5.013,0,0,1,.919.219,1.379,1.379,0,1,0,0-1.665,5.254,5.254,0,0,1-.919.215,5.262,5.262,0,0,1-.92-.215,1.375,1.375,0,1,0-1.091,2.209M93.05,78.118a1.372,1.372,0,0,0-2.586-.3,5.137,5.137,0,0,1-.855.4,5.051,5.051,0,0,1-.944-.021,1.373,1.373,0,1,0-1.328,2.342c-.1.069-.2.141-.289.209-.092-.022-.183-.051-.276-.07a5.271,5.271,0,0,0-.264-.465c-.136-.2-.281-.373-.416-.4a.318.318,0,0,0-.062-.009c-.12-.012-.354-.013-.55-.013a5.086,5.086,0,0,0-.61.022c-.232.055-.5.517-.679.868-.094.02-.185.048-.278.07-.312-.24-.763-.547-1-.493a4.84,4.84,0,0,0-.56.246,5.042,5.042,0,0,0-.541.284c-.188.151-.231.692-.236,1.088-.075.058-.15.112-.225.174-.384-.085-.918-.163-1.1-.013a4.511,4.511,0,0,0-.4.464,4.943,4.943,0,0,0-.363.491c-.1.217.093.724.259,1.08-.043.083-.085.17-.124.255-.384.091-.9.254-1,.471a4.623,4.623,0,0,0-.157.589,4.441,4.441,0,0,0-.115.6c0,.24.395.613.7.86,0,.048-.008.095-.008.142s.006.093.008.141c-.307.251-.7.622-.7.861a5.24,5.24,0,0,0,.113.6,5.014,5.014,0,0,0,.16.588c.1.218.62.38,1,.472.04.085.081.172.124.255-.168.357-.364.864-.259,1.079a4.866,4.866,0,0,0,.363.49,4.532,4.532,0,0,0,.4.464c.187.149.718.072,1.1-.012.073.062.149.116.225.173,0,.4.047.937.236,1.087a7.88,7.88,0,0,0,1.1.531c.233.053.685-.251,1-.494.093.023.183.051.278.07.176.352.447.818.679.87a4.771,4.771,0,0,0,.61.022,4.923,4.923,0,0,0,.611-.022c.231-.052.5-.516.68-.87.093-.017.184-.047.276-.069.1.075.21.154.324.23a1.375,1.375,0,1,0,1.445,2.16,5.02,5.02,0,0,1,.92-.219,5.014,5.014,0,0,1,.919.219,1.379,1.379,0,1,0,0-1.665,5.255,5.255,0,0,1-.919.215,5.262,5.262,0,0,1-.92-.215,1.39,1.39,0,0,0-.435-.372l.223-.1a5.15,5.15,0,0,0,.541-.287c.187-.15.229-.691.233-1.086.075-.059.153-.113.227-.174.385.083.917.161,1.105.011a4.588,4.588,0,0,0,.4-.463,5.069,5.069,0,0,0,.365-.492c.1-.215-.092-.72-.26-1.079.044-.085.083-.168.124-.256.382-.093.9-.252,1.005-.47a5.009,5.009,0,0,0,.157-.591,4.947,4.947,0,0,0,.114-.6c0-.24-.4-.61-.7-.861,0-.047.009-.093.009-.141s-.006-.094-.009-.142c.308-.248.7-.62.7-.86a5.441,5.441,0,0,0-.115-.6,5,5,0,0,0-.157-.591c-.1-.217-.622-.38-1-.471-.041-.085-.08-.172-.124-.255.168-.357.363-.864.26-1.08a8.749,8.749,0,0,0-.762-.955c-.188-.149-.72-.071-1.106.013-.073-.062-.151-.116-.225-.175-.006-.4-.048-.936-.235-1.087A5.122,5.122,0,0,0,88.6,80.5l-.157-.075a1.385,1.385,0,0,0,.561-.6,5.066,5.066,0,0,1,.854-.4,4.875,4.875,0,0,1,.944.025,1.374,1.374,0,0,0,2.243-1.327m7.584-1.37a1.374,1.374,0,0,0-2.583-.34,5.2,5.2,0,0,1-.86.389,5.115,5.115,0,0,1-.943-.036,1.378,1.378,0,1,0,.319,1.634,4.987,4.987,0,0,1,.86-.39,5,5,0,0,1,.943.037,1.373,1.373,0,0,0,2.262-1.294m7.615-1.162a1.373,1.373,0,0,0-2.549-.535,5.265,5.265,0,0,1-.886.321,5.066,5.066,0,0,1-.939-.108,1.378,1.378,0,1,0,.2,1.653,5.033,5.033,0,0,1,.887-.323,4.946,4.946,0,0,1,.938.108,1.372,1.372,0,0,0,2.354-1.117m7.995.385c-.111.026-.242.248-.324.418-.047.01-.091.022-.134.033-.149-.115-.367-.263-.478-.237l-.013,0a1.375,1.375,0,1,0-2-1.825,5.173,5.173,0,0,1-.9.3,5.1,5.1,0,0,1-.934-.134,1.379,1.379,0,1,0,.148,1.659,5.02,5.02,0,0,1,.9-.3,5.083,5.083,0,0,1,.935.135,1.369,1.369,0,0,0,1.136.447,1.444,1.444,0,0,0,.213-.041l-.017.01c-.09.072-.111.332-.113.522-.036.027-.072.054-.108.082-.185-.04-.44-.075-.531-.006a2.307,2.307,0,0,0-.191.222,2.652,2.652,0,0,0-.173.236c-.051.105.044.346.123.518-.021.04-.04.082-.059.124-.183.043-.432.12-.481.225a1.972,1.972,0,0,0-.074.282,2.121,2.121,0,0,0-.056.288c0,.115.191.293.336.414q0,.032,0,.066c0,.022,0,.044,0,.068-.145.119-.336.3-.336.413a2.53,2.53,0,0,0,.053.286,2.27,2.27,0,0,0,.078.283c.049.105.3.183.481.225.018.043.038.084.059.123-.079.172-.173.414-.123.52a2.3,2.3,0,0,0,.173.232,2.437,2.437,0,0,0,.191.224c.09.071.344.034.531-.006.034.028.072.056.108.083,0,.189.023.449.113.523a2.654,2.654,0,0,0,.259.136,2.336,2.336,0,0,0,.269.116c.111.028.327-.121.478-.236.043.009.087.025.134.032.082.169.213.393.324.418a1.967,1.967,0,0,0,.293.009,2.319,2.319,0,0,0,.292-.009c.111-.025.242-.248.327-.418.044-.007.09-.023.134-.032.149.115.365.263.477.236a2.681,2.681,0,0,0,.27-.117c.1-.048.226-.112.259-.136.089-.074.109-.334.111-.523.038-.027.074-.055.11-.082.183.039.44.076.528,0a1.964,1.964,0,0,0,.191-.221c.071-.09.157-.2.176-.236.049-.105-.044-.346-.125-.52.022-.04.04-.081.059-.123.183-.043.433-.12.484-.225a2.582,2.582,0,0,0,.074-.283,2.621,2.621,0,0,0,.055-.286c0-.114-.191-.294-.337-.413,0-.024,0-.045,0-.068s0-.045,0-.066c.145-.121.337-.3.337-.414a4.166,4.166,0,0,0-.129-.57c-.051-.105-.3-.183-.484-.225-.019-.042-.036-.084-.059-.124.081-.172.174-.413.125-.518a2.372,2.372,0,0,0-.176-.235,2.127,2.127,0,0,0-.191-.223c-.089-.07-.345-.034-.53.006-.034-.028-.07-.055-.108-.082,0-.19-.022-.45-.111-.522a2.675,2.675,0,0,0-.259-.135,2.166,2.166,0,0,0-.27-.119c-.111-.026-.328.122-.477.237l-.134-.033a2.308,2.308,0,0,0-.126-.225c-.066-.1-.136-.179-.2-.193a.218.218,0,0,0-.028,0c-.058-.006-.17-.006-.263-.006a2.578,2.578,0,0,0-.293.009M123.4,74.19a1.373,1.373,0,0,0-2.546-.552,5.176,5.176,0,0,1-.888.315,5.026,5.026,0,0,1-.939-.113,1.378,1.378,0,1,0,.184,1.655,5.154,5.154,0,0,1,.89-.319,5.171,5.171,0,0,1,.936.115,1.374,1.374,0,0,0,2.363-1.1m6.128-1.832a1.366,1.366,0,0,0-1.057.612,5.184,5.184,0,0,1-.9.272,5.062,5.062,0,0,1-.929-.159,1.378,1.378,0,1,0,.1,1.662,4.983,4.983,0,0,1,.9-.274,4.969,4.969,0,0,1,.93.161,1.375,1.375,0,1,0,.954-2.273m1.949,3.733c-.047.009-.09.022-.134.033-.149-.115-.366-.263-.478-.238A2.26,2.26,0,0,0,130.6,76a2.125,2.125,0,0,0-.259.136c-.09.072-.111.332-.112.521-.036.027-.073.055-.108.083-.185-.04-.44-.077-.531-.006a2.12,2.12,0,0,0-.191.222c-.07.089-.156.2-.174.236-.05.105.044.346.124.518a1.258,1.258,0,0,0-.058.124c-.184.043-.433.12-.482.225a2.168,2.168,0,0,0-.075.283,2.3,2.3,0,0,0-.055.288c0,.114.19.293.335.414,0,.022,0,.043,0,.066s0,.045,0,.069c-.145.119-.335.3-.335.413a2.358,2.358,0,0,0,.053.286,2.412,2.412,0,0,0,.077.282c.05.106.3.183.482.226a1.1,1.1,0,0,0,.058.123c-.08.172-.174.414-.124.518a2.473,2.473,0,0,0,.174.234,2.824,2.824,0,0,0,.191.224c.09.071.345.034.531-.006.035.028.072.056.108.082,0,.19.022.45.112.522a2.663,2.663,0,0,0,.259.137,2.154,2.154,0,0,0,.268.116c.111.027.327-.12.478-.236.044.011.088.027.134.034.082.169.213.393.325.418a1.941,1.941,0,0,0,.293.009,2.335,2.335,0,0,0,.293-.009c.112-.025.242-.247.325-.418.045-.007.091-.023.134-.034.149.116.367.263.478.238a2.742,2.742,0,0,0,.269-.118,2.63,2.63,0,0,0,.259-.137c.09-.072.11-.332.112-.522.037-.026.074-.054.109-.082.183.04.44.077.53.006a2.009,2.009,0,0,0,.191-.221,2.326,2.326,0,0,0,.175-.236c.051-.1-.043-.346-.123-.518.021-.04.039-.081.059-.123.183-.043.433-.12.482-.225a2.24,2.24,0,0,0,.075-.283,2.582,2.582,0,0,0,.054-.286c0-.115-.19-.294-.336-.413,0-.024,0-.046,0-.069s0-.043,0-.066c.146-.121.336-.3.336-.414a2.66,2.66,0,0,0-.054-.288,2.165,2.165,0,0,0-.075-.283c-.05-.1-.3-.182-.482-.225-.02-.042-.037-.084-.059-.124.08-.172.174-.413.123-.518a2.032,2.032,0,0,0-.175-.235,2.145,2.145,0,0,0-.191-.223c-.09-.071-.346-.035-.531.006-.033-.028-.07-.056-.108-.083,0-.189-.021-.449-.112-.521a2.1,2.1,0,0,0-.259-.136,2.441,2.441,0,0,0-.269-.119c-.112-.025-.33.123-.478.238-.043-.011-.089-.025-.134-.033-.036-.072-.078-.151-.124-.225-.066-.1-.136-.179-.2-.193a.1.1,0,0,0-.029,0,2.555,2.555,0,0,0-.263-.008,2.458,2.458,0,0,0-.293.01c-.112.026-.243.248-.325.418m5.714-3.611a1.368,1.368,0,0,0-1.092.545,5.128,5.128,0,0,1-.919.217,5.136,5.136,0,0,1-.92-.217,1.378,1.378,0,1,0,0,1.665,5,5,0,0,1,.92-.216,4.992,4.992,0,0,1,.919.216,1.375,1.375,0,1,0,1.092-2.209m7.673.157a1.368,1.368,0,0,0-1.131.459,2.055,2.055,0,0,1-1.831-.138,1.379,1.379,0,1,0-.127,1.66,2.051,2.051,0,0,1,1.832.139,1.375,1.375,0,1,0,1.257-2.121m7.58.717a1.365,1.365,0,0,0-1.132.457,5.259,5.259,0,0,1-.935.142,5.052,5.052,0,0,1-.9-.29,1.378,1.378,0,1,0-.134,1.659,5.079,5.079,0,0,1,.934-.142,4.938,4.938,0,0,1,.9.291,1.375,1.375,0,1,0,1.266-2.117m1.772,5.263a2.382,2.382,0,0,0-.074-.281c-.051-.106-.3-.183-.482-.226-.021-.043-.037-.083-.059-.125.08-.17.173-.412.123-.516a2.372,2.372,0,0,0-.175-.236,2.282,2.282,0,0,0-.191-.222c-.089-.07-.346-.034-.531.006-.034-.028-.07-.057-.108-.084,0-.188-.022-.448-.111-.522a2.837,2.837,0,0,0-.259-.135,2.339,2.339,0,0,0-.269-.118c-.111-.027-.329.123-.478.238-.043-.011-.089-.025-.134-.034a2.041,2.041,0,0,0-.125-.224c-.066-.1-.136-.18-.2-.194l-.029,0c-.057-.006-.17-.006-.263-.006a2.343,2.343,0,0,0-.293.009c-.111.025-.242.248-.324.418-.047.009-.091.023-.134.034-.149-.115-.366-.265-.478-.238a2.28,2.28,0,0,0-.268.118,2.6,2.6,0,0,0-.259.135c-.091.074-.111.334-.112.522-.037.027-.073.055-.109.084-.185-.04-.44-.077-.53-.006a2.171,2.171,0,0,0-.191.221c-.07.09-.156.2-.174.237-.05.1.044.346.124.516-.021.042-.041.082-.059.125-.184.043-.432.12-.482.226a1.985,1.985,0,0,0-.074.281,2.425,2.425,0,0,0-.055.288c0,.115.191.293.336.414,0,.022,0,.043,0,.066s0,.045,0,.068c-.146.119-.336.3-.336.414a2.549,2.549,0,0,0,.053.285,2.362,2.362,0,0,0,.077.282c.051.106.3.183.482.226a1.372,1.372,0,0,0,.059.124c-.081.172-.174.414-.124.518a2.481,2.481,0,0,0,.174.234,2.242,2.242,0,0,0,.191.222c.09.071.344.036.53,0,.035.028.072.055.109.082,0,.19.021.448.112.522a4.168,4.168,0,0,0,.527.254c.112.026.328-.122.478-.237.043.011.087.025.134.034.082.168.213.393.324.417a2.041,2.041,0,0,0,.293.01,2.463,2.463,0,0,0,.293-.01c.111-.024.242-.247.325-.417.044-.009.09-.023.134-.034.149.115.366.263.478.237a2.5,2.5,0,0,0,.269-.118,2.617,2.617,0,0,0,.259-.136c.089-.074.11-.332.111-.522.038-.028.074-.054.109-.082.184.04.44.075.529,0a1.9,1.9,0,0,0,.191-.221,2.484,2.484,0,0,0,.175-.236c.05-.1-.043-.346-.123-.518.021-.04.038-.081.059-.124.183-.043.432-.12.482-.226a2.475,2.475,0,0,0,.074-.282,2.344,2.344,0,0,0,.055-.285c0-.116-.191-.294-.337-.414,0-.023,0-.044,0-.068s0-.044,0-.066c.146-.122.337-.3.337-.414a2.48,2.48,0,0,0-.055-.288m5.85-4.465a1.369,1.369,0,0,0-1.151.41,2.057,2.057,0,0,1-1.823-.224,1.378,1.378,0,1,0-.2,1.652,2.053,2.053,0,0,1,1.824.224,1.375,1.375,0,1,0,1.352-2.062m7.6.758a1.37,1.37,0,0,0-1.159.383,5.153,5.153,0,0,1-.94.081,5.031,5.031,0,0,1-.879-.346,1.377,1.377,0,1,0-.24,1.648,4.831,4.831,0,0,1,.941-.084,5.056,5.056,0,0,1,.878.348,1.376,1.376,0,1,0,1.4-2.031m7.549,1.367a1.367,1.367,0,0,0-1.15.409,2.056,2.056,0,0,1-1.824-.221,1.378,1.378,0,1,0-.2,1.653,2.054,2.054,0,0,1,1.824.222,1.375,1.375,0,1,0,1.351-2.062"
          transform="translate(-71.28 -14.889)"
          fill="#3b3c3d"
        />
        <path
          id="Path_21046"
          data-name="Path 21046"
          d="M146.146,76.856c.093,0,.206,0,.263.007a.1.1,0,0,1,.029,0c.065.014.134.1.2.193a2.381,2.381,0,0,1,.125.225c.044.009.09.021.133.032.149-.115.367-.263.478-.238a2.813,2.813,0,0,1,.269.119,2.242,2.242,0,0,1,.259.136c.089.073.11.333.111.521.038.028.074.055.108.084.185-.041.441-.077.531-.006a2.025,2.025,0,0,1,.191.222,1.938,1.938,0,0,1,.175.235c.051.105-.043.347-.123.518.021.041.039.082.059.124.183.043.433.121.483.225a2.378,2.378,0,0,1,.074.283,2.708,2.708,0,0,1,.055.288c0,.114-.191.293-.337.414,0,.022,0,.044,0,.066s0,.045,0,.07c.146.118.337.3.337.412a2.625,2.625,0,0,1-.055.286,2.337,2.337,0,0,1-.074.283c-.051.106-.3.183-.483.225-.02.043-.037.085-.059.124.08.172.174.414.123.518a2.3,2.3,0,0,1-.175.236,1.929,1.929,0,0,1-.191.221c-.09.071-.346.034-.529-.006-.036.028-.072.056-.11.082,0,.19-.021.45-.111.523a2.7,2.7,0,0,1-.259.136c-.1.049-.229.108-.269.119-.112.025-.33-.122-.478-.238-.043.011-.089.026-.133.034-.084.17-.213.392-.326.417a2.336,2.336,0,0,1-.293.009,1.947,1.947,0,0,1-.293-.009c-.111-.025-.243-.248-.325-.417-.047-.008-.09-.023-.134-.034-.15.116-.365.263-.478.236a2.207,2.207,0,0,1-.268-.116,2.7,2.7,0,0,1-.259-.136c-.09-.073-.111-.333-.112-.523-.036-.026-.074-.054-.108-.082-.187.04-.441.077-.531.006a2.412,2.412,0,0,1-.191-.224,2.319,2.319,0,0,1-.174-.233c-.051-.1.043-.346.123-.518a1.114,1.114,0,0,1-.058-.124c-.184-.043-.433-.119-.482-.226a2.483,2.483,0,0,1-.077-.282,2.53,2.53,0,0,1-.053-.286c0-.115.19-.294.335-.412,0-.025,0-.047,0-.07s0-.043,0-.066c-.146-.121-.335-.3-.335-.414a2.324,2.324,0,0,1,.055-.288,2.348,2.348,0,0,1,.075-.283c.05-.1.3-.182.482-.225a1.354,1.354,0,0,1,.058-.124c-.08-.171-.174-.413-.123-.518a2.691,2.691,0,0,1,.174-.236,1.921,1.921,0,0,1,.191-.221c.089-.071.346-.036.531.006.035-.028.071-.056.108-.084,0-.188.022-.448.112-.521a2.243,2.243,0,0,1,.259-.136,2.65,2.65,0,0,1,.268-.119c.112-.025.33.123.478.238.044-.011.088-.024.134-.032.082-.17.213-.392.325-.418a2.507,2.507,0,0,1,.293-.009m-1.765,3.438a1.61,1.61,0,1,0,1.608-1.608,1.61,1.61,0,0,0-1.608,1.608"
          transform="translate(-85.331 -16.081)"
          fill="#48494a"
        />
        <path
          id="Path_21047"
          data-name="Path 21047"
          d="M148.432,80.778a1.61,1.61,0,1,1-1.611-1.608,1.61,1.61,0,0,1,1.611,1.608"
          transform="translate(-86.163 -16.566)"
          fill="#707173"
        />
        <path
          id="Path_21048"
          data-name="Path 21048"
          d="M166.114,77.242c.065.014.134.1.2.193a2.313,2.313,0,0,1,.126.225l.134.033c.149-.115.365-.263.477-.237a2.166,2.166,0,0,1,.27.119,2.661,2.661,0,0,1,.259.135c.089.072.109.332.111.522.038.027.074.054.108.082.185-.04.441-.075.53-.006a2.133,2.133,0,0,1,.191.223,2.384,2.384,0,0,1,.176.235c.049.105-.044.346-.125.518.022.04.04.082.059.124.183.043.433.12.484.225a4.177,4.177,0,0,1,.129.57c0,.115-.191.293-.337.414,0,.021,0,.044,0,.066s0,.044,0,.068c.145.119.337.3.337.413a2.625,2.625,0,0,1-.055.286,2.579,2.579,0,0,1-.074.283c-.051.105-.3.183-.484.225-.019.043-.036.084-.059.123.081.174.174.414.125.52-.018.034-.1.146-.176.236a1.969,1.969,0,0,1-.191.221c-.089.071-.345.034-.528,0-.036.028-.072.055-.11.082,0,.189-.022.449-.111.523-.033.024-.16.088-.259.136a2.689,2.689,0,0,1-.27.117c-.111.027-.328-.122-.477-.236-.044.009-.09.025-.134.032-.085.17-.215.393-.327.418a2.316,2.316,0,0,1-.292.009,1.965,1.965,0,0,1-.293-.009c-.111-.025-.242-.248-.324-.418-.047-.007-.091-.023-.134-.032-.151.115-.367.263-.478.236a2.338,2.338,0,0,1-.269-.116,2.662,2.662,0,0,1-.259-.136c-.09-.074-.111-.334-.113-.523-.036-.027-.074-.055-.108-.083-.187.04-.44.077-.531.006a2.437,2.437,0,0,1-.191-.224,2.291,2.291,0,0,1-.173-.232c-.051-.105.043-.347.123-.52-.021-.04-.04-.081-.058-.123-.183-.043-.432-.12-.481-.225a2.261,2.261,0,0,1-.077-.283,2.526,2.526,0,0,1-.053-.286c0-.114.191-.294.336-.413,0-.024,0-.046,0-.068s0-.045,0-.066c-.145-.121-.336-.3-.336-.414a2.1,2.1,0,0,1,.056-.288,1.965,1.965,0,0,1,.074-.282c.049-.105.3-.183.481-.225.018-.042.038-.084.058-.124-.079-.172-.173-.413-.123-.518a2.643,2.643,0,0,1,.173-.236,2.313,2.313,0,0,1,.191-.222c.09-.07.346-.034.531.006.036-.028.072-.055.108-.082,0-.19.023-.45.113-.522l.017-.01a1.345,1.345,0,0,0,.5-.239l.013,0c.111-.026.329.122.478.237.043-.011.087-.023.134-.033.082-.17.213-.391.324-.418a2.573,2.573,0,0,1,.293-.009c.093,0,.206,0,.263.006a.213.213,0,0,1,.028,0m-.448,1.821a1.608,1.608,0,1,0,1.609,1.608,1.608,1.608,0,0,0-1.609-1.608"
          transform="translate(-120.565 -16.161)"
          fill="#48494a"
        />
        <path
          id="Path_21049"
          data-name="Path 21049"
          d="M168.108,81.155a1.609,1.609,0,1,1-1.609-1.608,1.608,1.608,0,0,1,1.609,1.608"
          transform="translate(-121.398 -16.646)"
          fill="#707173"
        />
        <path
          id="Path_21050"
          data-name="Path 21050"
          d="M125.511,80.583c0,.022,0,.043,0,.066s0,.045,0,.068c.145.12.337.3.337.414a2.436,2.436,0,0,1-.055.285,2.506,2.506,0,0,1-.074.283c-.051.105-.3.183-.482.226-.021.043-.037.083-.059.124.081.172.174.414.124.518a2.525,2.525,0,0,1-.176.236,1.981,1.981,0,0,1-.191.221c-.089.071-.346.035-.529,0-.036.028-.072.055-.109.082,0,.19-.022.449-.112.523a2.664,2.664,0,0,1-.259.136,2.514,2.514,0,0,1-.27.117c-.111.027-.328-.122-.477-.236-.044.011-.089.025-.134.034-.084.17-.214.392-.326.417a2.505,2.505,0,0,1-.293.009,2.059,2.059,0,0,1-.293-.009c-.112-.025-.243-.249-.325-.417-.047-.009-.09-.023-.134-.034-.15.115-.365.263-.478.236a2.327,2.327,0,0,1-.268-.117,2.7,2.7,0,0,1-.259-.136c-.09-.074-.111-.333-.112-.523-.037-.027-.075-.054-.109-.082-.186.04-.44.076-.531,0a2.517,2.517,0,0,1-.191-.223,2.316,2.316,0,0,1-.173-.233c-.051-.1.043-.347.123-.518-.021-.041-.041-.081-.059-.124-.183-.043-.432-.121-.482-.226a3.727,3.727,0,0,1-.13-.569c0-.116.191-.293.336-.414,0-.023,0-.044,0-.068s0-.043,0-.066c-.145-.122-.336-.3-.336-.415a2.49,2.49,0,0,1,.056-.287,1.983,1.983,0,0,1,.074-.281c.05-.107.3-.183.482-.226.017-.043.037-.083.059-.125-.08-.17-.174-.413-.123-.517a2.8,2.8,0,0,1,.173-.236,2.312,2.312,0,0,1,.191-.222c.09-.07.346-.034.531.007.036-.028.072-.057.109-.084,0-.188.021-.448.112-.522a2.563,2.563,0,0,1,.259-.135,2.26,2.26,0,0,1,.268-.119c.112-.026.329.123.478.238.044-.01.088-.024.134-.034.082-.17.213-.391.325-.417a2.333,2.333,0,0,1,.293-.009c.093,0,.206,0,.263.006a.139.139,0,0,1,.029,0c.065.014.134.1.2.193a2.36,2.36,0,0,1,.125.224l.134.034c.149-.115.366-.264.477-.238a2.438,2.438,0,0,1,.27.119,2.527,2.527,0,0,1,.259.135c.09.074.11.334.112.522.037.027.074.055.108.084.185-.041.441-.077.531-.007a2.236,2.236,0,0,1,.191.223,2.33,2.33,0,0,1,.176.236c.05.1-.043.347-.124.517.022.042.039.082.059.125.183.043.432.119.482.226a2.387,2.387,0,0,1,.074.281,2.607,2.607,0,0,1,.055.287c0,.115-.191.293-.337.415m-3.24-1.555a1.609,1.609,0,1,0,1.61,1.608,1.608,1.608,0,0,0-1.61-1.608"
          transform="translate(-42.857 -16.154)"
          fill="#48494a"
        />
        <path
          id="Path_21051"
          data-name="Path 21051"
          d="M124.713,81.121a1.609,1.609,0,1,1-1.61-1.608,1.609,1.609,0,0,1,1.61,1.608"
          transform="translate(-43.688 -16.637)"
          fill="#707173"
        />
        <path
          id="Path_21052"
          data-name="Path 21052"
          d="M197.828,99.837a.943.943,0,1,1-.943.94.942.942,0,0,1,.943-.94"
          transform="translate(-177.362 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21053"
          data-name="Path 21053"
          d="M203.854,100.777a.943.943,0,1,1-.943-.94.944.944,0,0,1,.943.94"
          transform="translate(-186.465 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21054"
          data-name="Path 21054"
          d="M192.6,99.612a2.086,2.086,0,0,0,.267.118.38.38,0,0,0,.229-.068,1.374,1.374,0,1,1-2.032,1.835,2.042,2.042,0,0,0-1.837,0,1.379,1.379,0,1,1,0-1.665,2.069,2.069,0,0,0,1.837,0,1.37,1.37,0,0,1,1.094-.546c.036,0,.069.008.1.01a.328.328,0,0,0,.079.18,2.369,2.369,0,0,0,.259.136m-4.465.11a.943.943,0,1,0,.944.94.942.942,0,0,0-.944-.94m3.078.94a.943.943,0,1,0,.945-.94.944.944,0,0,0-.945.94"
          transform="translate(-164.114 -20.775)"
          fill="#505152"
        />
        <path
          id="Path_21055"
          data-name="Path 21055"
          d="M189.193,100.777a.943.943,0,1,1-.941-.94.942.942,0,0,1,.941.94"
          transform="translate(-160.211 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21056"
          data-name="Path 21056"
          d="M193.334,101.723a.943.943,0,1,1,.943-.946.943.943,0,0,1-.943.946"
          transform="translate(-169.315 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21057"
          data-name="Path 21057"
          d="M178.442,99.612a2.413,2.413,0,0,0,.259-.136.3.3,0,0,0,.075-.163,1.382,1.382,0,0,1,.872.52,5.086,5.086,0,0,0,.919.215,5.164,5.164,0,0,0,.919-.215,1.377,1.377,0,1,1,0,1.665,4.987,4.987,0,0,0-.919-.218,4.913,4.913,0,0,0-.919.218,1.375,1.375,0,1,1-1.886-1.956c.142.1.315.21.41.188a1.985,1.985,0,0,0,.27-.118m4.134,2a.943.943,0,1,0-.942-.946.944.944,0,0,0,.942.946m-4.963-.946a.943.943,0,1,0,.941-.94.943.943,0,0,0-.941.94"
          transform="translate(-146.962 -20.775)"
          fill="#505152"
        />
        <path
          id="Path_21058"
          data-name="Path 21058"
          d="M178.67,99.837a.943.943,0,1,1-.943.94.942.942,0,0,1,.943-.94"
          transform="translate(-143.055 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21059"
          data-name="Path 21059"
          d="M184.7,100.777a.943.943,0,1,1-.944-.94.945.945,0,0,1,.944.94"
          transform="translate(-152.16 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21060"
          data-name="Path 21060"
          d="M172.709,99.612a2.064,2.064,0,0,0,.263.115.915.915,0,1,0,.046,0,1.046,1.046,0,0,0,.437-.233c.043.011.088.025.134.034.082.169.214.393.324.417a2.016,2.016,0,0,0,.26.011,1.361,1.361,0,0,1,.2.708,1.373,1.373,0,0,1-2.469.835,2.044,2.044,0,0,0-1.838,0,1.379,1.379,0,1,1,0-1.665,2.07,2.07,0,0,0,1.838,0,1.4,1.4,0,0,1,.508-.41.2.2,0,0,0,.035.054,2.411,2.411,0,0,0,.259.136m-3.731.11a.943.943,0,1,0,.943.94.941.941,0,0,0-.943-.94"
          transform="translate(-129.811 -20.775)"
          fill="#505152"
        />
        <path
          id="Path_21061"
          data-name="Path 21061"
          d="M170.035,100.778a.943.943,0,1,1-.97-.935l0,0a.19.19,0,0,0,.041,0,.939.939,0,0,1,.924.936"
          transform="translate(-125.904 -20.892)"
          fill="#707173"
        />
        <path
          id="Path_21062"
          data-name="Path 21062"
          d="M174.176,101.723a.943.943,0,1,1,.943-.946.943.943,0,0,1-.943.946"
          transform="translate(-135.008 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21063"
          data-name="Path 21063"
          d="M158.814,99.476a.2.2,0,0,0,.052-.081,1.367,1.367,0,0,1,1.627.438,5.109,5.109,0,0,0,.92.215,5.181,5.181,0,0,0,.919-.215,1.377,1.377,0,1,1,0,1.665,5,5,0,0,0-.919-.218,4.935,4.935,0,0,0-.92.218,1.374,1.374,0,1,1-2.014-1.85l.076-.036a2.447,2.447,0,0,0,.259-.136m4.609,2.132a.943.943,0,1,0-.943-.946.943.943,0,0,0,.943.946m-4.021,0a.943.943,0,1,0-.943-.946.944.944,0,0,0,.943.946"
          transform="translate(-112.66 -20.775)"
          fill="#505152"
        />
        <path
          id="Path_21064"
          data-name="Path 21064"
          d="M159.515,99.837a.943.943,0,1,1-.943.94.941.941,0,0,1,.943-.94"
          transform="translate(-108.752 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21065"
          data-name="Path 21065"
          d="M164.6,99.837a.943.943,0,1,1-.943.94.942.942,0,0,1,.943-.94"
          transform="translate(-117.858 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21066"
          data-name="Path 21066"
          d="M153.566,99.492c.044.011.087.025.134.034a2,2,0,0,0,.112.2.94.94,0,1,0,.972.934.927.927,0,0,0-.342-.709,1.333,1.333,0,0,0,.168-.009c.073-.016.152-.118.222-.232a1.374,1.374,0,1,1-2.082,1.786,2.044,2.044,0,0,0-1.838,0,1.379,1.379,0,1,1,0-1.665,2.07,2.07,0,0,0,1.838,0,1.509,1.509,0,0,1,.166-.175,1.2,1.2,0,0,0,.172.072c.111.026.327-.121.478-.237m-3.745.229a.943.943,0,1,0,.943.94.941.941,0,0,0-.943-.94"
          transform="translate(-95.505 -20.775)"
          fill="#505152"
        />
        <path
          id="Path_21067"
          data-name="Path 21067"
          d="M150.879,100.779a.943.943,0,1,1-.972-.934c.068.107.143.2.212.215a2.278,2.278,0,0,0,.293.011l.125,0a.927.927,0,0,1,.342.709"
          transform="translate(-91.6 -20.892)"
          fill="#707173"
        />
        <path
          id="Path_21068"
          data-name="Path 21068"
          d="M155.02,101.723a.943.943,0,1,1,.943-.946.943.943,0,0,1-.943.946"
          transform="translate(-100.704 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21069"
          data-name="Path 21069"
          d="M140.245,99.286a1.37,1.37,0,0,1,1.091.546,2.072,2.072,0,0,0,1.839,0,1.377,1.377,0,1,1,0,1.665,2.045,2.045,0,0,0-1.839,0,1.376,1.376,0,1,1-1.091-2.211m4.021,2.322a.943.943,0,1,0-.943-.946.943.943,0,0,0,.943.946m-4.021,0a.943.943,0,1,0-.943-.946.944.944,0,0,0,.943.946"
          transform="translate(-78.355 -20.775)"
          fill="#505152"
        />
        <path
          id="Path_21070"
          data-name="Path 21070"
          d="M140.358,99.837a.943.943,0,1,1-.943.94.941.941,0,0,1,.943-.94"
          transform="translate(-74.446 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21071"
          data-name="Path 21071"
          d="M145.444,99.837a.943.943,0,1,1-.943.94.942.942,0,0,1,.943-.94"
          transform="translate(-83.554 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21072"
          data-name="Path 21072"
          d="M134.118,99.931a.922.922,0,0,0-.374.731.943.943,0,1,0,1.886,0,.927.927,0,0,0-.72-.9,2.128,2.128,0,0,0,.138-.24c.044-.009.09-.023.133-.034.149.116.367.263.478.237,0,0,.02-.008.027-.01a1.374,1.374,0,1,1-2.09,1.778,4.942,4.942,0,0,0-.919-.218,4.943,4.943,0,0,0-.919.218,1.379,1.379,0,1,1,0-1.665,5.118,5.118,0,0,0,.919.215,5.117,5.117,0,0,0,.919-.215,1.388,1.388,0,0,1,.248-.248.787.787,0,0,0,.274.346m-3.452-.21a.943.943,0,1,0,.943.94.942.942,0,0,0-.943-.94"
          transform="translate(-61.202 -20.775)"
          fill="#505152"
        />
        <path
          id="Path_21073"
          data-name="Path 21073"
          d="M131.724,100.789a.943.943,0,1,1-1.886,0,.922.922,0,0,1,.374-.731.129.129,0,0,0,.02.012,2.253,2.253,0,0,0,.293.011,2.428,2.428,0,0,0,.293-.011.4.4,0,0,0,.187-.177.928.928,0,0,1,.72.9"
          transform="translate(-57.297 -20.901)"
          fill="#707173"
        />
        <path
          id="Path_21074"
          data-name="Path 21074"
          d="M135.864,101.723a.943.943,0,1,1,.943-.946.944.944,0,0,1-.943.946"
          transform="translate(-66.4 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21075"
          data-name="Path 21075"
          d="M121.088,99.286a1.372,1.372,0,0,1,1.092.546,5.1,5.1,0,0,0,.919.215,5.118,5.118,0,0,0,.919-.215,1.377,1.377,0,1,1,0,1.665,4.943,4.943,0,0,0-.919-.218,4.928,4.928,0,0,0-.919.218,1.376,1.376,0,1,1-1.092-2.211m4.022,2.322a.943.943,0,1,0-.944-.946.942.942,0,0,0,.944.946m-4.022,0a.943.943,0,1,0-.942-.946.944.944,0,0,0,.942.946"
          transform="translate(-44.05 -20.775)"
          fill="#505152"
        />
        <path
          id="Path_21076"
          data-name="Path 21076"
          d="M121.205,99.837a.943.943,0,1,1-.944.94.941.941,0,0,1,.944-.94"
          transform="translate(-40.146 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21077"
          data-name="Path 21077"
          d="M126.286,99.837a.943.943,0,1,1-.942.94.943.943,0,0,1,.942-.94"
          transform="translate(-49.249 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21078"
          data-name="Path 21078"
          d="M114.541,99.954a2.415,2.415,0,0,0,.292-.011c.112-.024.242-.248.327-.417.043-.009.089-.023.132-.034.149.116.368.263.478.237a2.03,2.03,0,0,0,.27-.118c.081-.039.168-.083.218-.114a1.375,1.375,0,1,1-1.819,2,4.943,4.943,0,0,0-.919-.218,4.907,4.907,0,0,0-.918.218,1.379,1.379,0,1,1,0-1.665,5.08,5.08,0,0,0,.918.215,5.394,5.394,0,0,0,.663-.143.19.19,0,0,0,.065.039,2.141,2.141,0,0,0,.293.011m.99,1.653a.943.943,0,1,0-.943-.946.944.944,0,0,0,.943.946m-4.022-1.886a.943.943,0,1,0,.944.94.942.942,0,0,0-.944-.94"
          transform="translate(-26.898 -20.775)"
          fill="#505152"
        />
        <path
          id="Path_21079"
          data-name="Path 21079"
          d="M111.623,99.837a.943.943,0,1,1-.943.94.942.942,0,0,1,.943-.94"
          transform="translate(-22.99 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21080"
          data-name="Path 21080"
          d="M116.707,101.723a.943.943,0,1,1,.944-.946.943.943,0,0,1-.944.946"
          transform="translate(-32.095 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21081"
          data-name="Path 21081"
          d="M101.931,99.286a1.372,1.372,0,0,1,1.092.546,5.1,5.1,0,0,0,.919.215,5.149,5.149,0,0,0,.919-.215,1.377,1.377,0,1,1,0,1.665,4.972,4.972,0,0,0-.919-.218,4.929,4.929,0,0,0-.919.218,1.376,1.376,0,1,1-1.092-2.211m4.021,2.322a.943.943,0,1,0-.943-.946.944.944,0,0,0,.943.946m-4.021,0a.943.943,0,1,0-.943-.946.944.944,0,0,0,.943.946"
          transform="translate(-9.745 -20.775)"
          fill="#505152"
        />
        <path
          id="Path_21082"
          data-name="Path 21082"
          d="M102.045,99.837a.943.943,0,1,1-.943.94.942.942,0,0,1,.943-.94"
          transform="translate(-5.837 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21083"
          data-name="Path 21083"
          d="M107.13,99.837a.943.943,0,1,1-.943.94.942.942,0,0,1,.943-.94"
          transform="translate(-14.943 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21084"
          data-name="Path 21084"
          d="M92.353,99.286a1.37,1.37,0,0,1,1.092.546,5.118,5.118,0,0,0,.919.215,5.133,5.133,0,0,0,.919-.215,1.377,1.377,0,1,1,0,1.665,4.957,4.957,0,0,0-.919-.218,4.943,4.943,0,0,0-.919.218,1.376,1.376,0,1,1-1.092-2.211m4.021,2.322a.943.943,0,1,0-.943-.946.944.944,0,0,0,.943.946m-4.021,0a.943.943,0,1,0-.943-.946.944.944,0,0,0,.943.946"
          transform="translate(7.408 -20.775)"
          fill="#505152"
        />
        <path
          id="Path_21085"
          data-name="Path 21085"
          d="M92.467,99.837a.943.943,0,1,1-.943.94.943.943,0,0,1,.943-.94"
          transform="translate(11.313 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21086"
          data-name="Path 21086"
          d="M97.552,99.837a.943.943,0,1,1-.943.94.942.942,0,0,1,.943-.94"
          transform="translate(2.208 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21087"
          data-name="Path 21087"
          d="M82.889,101.723a.943.943,0,1,1,.943-.946.943.943,0,0,1-.943.946"
          transform="translate(28.466 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21088"
          data-name="Path 21088"
          d="M87.974,101.723a.943.943,0,1,1,.943-.946.944.944,0,0,1-.943.946"
          transform="translate(19.36 -20.89)"
          fill="#707173"
        />
        <path
          id="Path_21089"
          data-name="Path 21089"
          d="M209.976,81.3A1.368,1.368,0,0,1,208.8,81a2.04,2.04,0,0,0-1.8.379,1.387,1.387,0,0,1-.561.6l.157.075a5.278,5.278,0,0,1,.541.284c.187.152.229.693.235,1.087.074.059.152.113.225.175.386-.085.918-.163,1.106-.013a5.063,5.063,0,0,1,.4.464,4.8,4.8,0,0,1,.365.492c.1.216-.092.723-.26,1.079.044.084.083.17.124.255.382.092.9.254,1,.471a4.982,4.982,0,0,1,.157.59,5.414,5.414,0,0,1,.115.6c0,.24-.4.612-.7.86,0,.048.009.095.009.143s-.006.093-.009.14c.307.251.7.622.7.862a8.487,8.487,0,0,1-.27,1.19c-.105.217-.623.377-1.005.47-.041.088-.08.172-.124.257.168.357.363.864.26,1.078a5.072,5.072,0,0,1-.365.492,4.62,4.62,0,0,1-.4.463c-.188.149-.72.071-1.105-.011-.074.06-.152.115-.227.173,0,.4-.047.936-.233,1.087a5.18,5.18,0,0,1-.541.286l-.223.1a1.377,1.377,0,0,1,.435.372,2.072,2.072,0,0,0,1.839,0,1.377,1.377,0,1,1,0,1.665,2.045,2.045,0,0,0-1.839,0A1.374,1.374,0,1,1,205.36,95c-.115-.075-.226-.154-.324-.23-.092.022-.183.051-.276.069-.177.353-.449.818-.68.87a4.919,4.919,0,0,1-.611.022,4.621,4.621,0,0,1-.61-.022c-.232-.052-.5-.517-.679-.87-.094-.018-.185-.047-.278-.07-.312.243-.763.548-1,.494a4.863,4.863,0,0,1-.56-.244,5.02,5.02,0,0,1-.541-.286c-.188-.15-.231-.691-.236-1.087-.075-.058-.152-.112-.225-.174-.387.084-.918.161-1.1.013a4.63,4.63,0,0,1-.4-.464,4.948,4.948,0,0,1-.363-.491c-.1-.214.092-.723.259-1.079-.044-.083-.085-.17-.124-.255-.384-.093-.9-.254-1-.472a4.986,4.986,0,0,1-.16-.588,5.266,5.266,0,0,1-.113-.6c0-.24.4-.611.7-.862,0-.047-.008-.094-.008-.14s.006-.095.008-.143c-.307-.248-.7-.62-.7-.86a4.4,4.4,0,0,1,.115-.6,4.588,4.588,0,0,1,.157-.589c.1-.217.62-.38,1-.471.04-.085.081-.172.124-.255-.167-.357-.364-.864-.259-1.079a4.84,4.84,0,0,1,.363-.492,4.6,4.6,0,0,1,.4-.464c.187-.149.72-.071,1.1.013.074-.062.149-.116.225-.173,0-.4.047-.937.236-1.089a5.192,5.192,0,0,1,.541-.284,4.982,4.982,0,0,1,.56-.246c.233-.054.685.254,1,.493.092-.021.183-.05.278-.07.176-.351.447-.814.679-.869a5.085,5.085,0,0,1,.61-.022c.2,0,.429,0,.55.013a.272.272,0,0,1,.062.009c.135.031.28.2.416.4a5.28,5.28,0,0,1,.264.466c.093.02.184.048.276.07.088-.068.187-.139.289-.208a1.374,1.374,0,1,1,1.328-2.343,5.123,5.123,0,0,0,.944.021,5.211,5.211,0,0,0,.855-.4,1.375,1.375,0,1,1,1.524,1.937m-.241,15.971a.943.943,0,1,0-.943-.946.943.943,0,0,0,.943.946m-4.963-.946a.943.943,0,1,0,.941-.94.943.943,0,0,0-.941.94m-5.434-7.795a4.131,4.131,0,1,0,4.131-4.13,4.131,4.131,0,0,0-4.131,4.13m7.342-7.945a.943.943,0,1,0-.728,1.119.943.943,0,0,0,.728-1.119m3.933-.83a.943.943,0,1,0-.726,1.119.941.941,0,0,0,.726-1.119"
          transform="translate(-189.268 -16.443)"
          fill="#505152"
        />
        <path
          id="Path_21090"
          data-name="Path 21090"
          d="M198.08,80.994a.944.944,0,1,1,.726-1.119.945.945,0,0,1-.726,1.119"
          transform="translate(-177.461 -16.556)"
          fill="#707173"
        />
        <path
          id="Path_21091"
          data-name="Path 21091"
          d="M203.052,82.043a.943.943,0,1,1,.728-1.119.943.943,0,0,1-.728,1.119"
          transform="translate(-186.368 -16.777)"
          fill="#707173"
        />
        <path
          id="Path_21092"
          data-name="Path 21092"
          d="M192.394,79.554a1.373,1.373,0,0,1-1.177-.326,4.875,4.875,0,0,0-.944-.037,4.982,4.982,0,0,0-.86.389,1.376,1.376,0,1,1-.319-1.634,2.056,2.056,0,0,0,1.8-.352,1.376,1.376,0,1,1,1.5,1.96M188,78.047a.944.944,0,1,0,1.106.743A.942.942,0,0,0,188,78.047m3.948-.773a.943.943,0,1,0,1.1.744.943.943,0,0,0-1.1-.744"
          transform="translate(-164.127 -16.074)"
          fill="#505152"
        />
        <path
          id="Path_21093"
          data-name="Path 21093"
          d="M188.478,79.241a.943.943,0,1,1,.744-1.108.944.944,0,0,1-.744,1.108"
          transform="translate(-160.294 -16.19)"
          fill="#707173"
        />
        <path
          id="Path_21094"
          data-name="Path 21094"
          d="M193.468,80.218a.944.944,0,1,1,.743-1.109.945.945,0,0,1-.743,1.109"
          transform="translate(-169.229 -16.394)"
          fill="#707173"
        />
        <path
          id="Path_21095"
          data-name="Path 21095"
          d="M182.729,77.967a1.371,1.371,0,0,1-1.148-.415,4.877,4.877,0,0,0-.937-.108,5.032,5.032,0,0,0-.887.323,1.378,1.378,0,1,1-.2-1.653,5.05,5.05,0,0,0,.939.108,5.26,5.26,0,0,0,.886-.321,1.376,1.376,0,1,1,1.343,2.067m-4.265-1.836a.943.943,0,1,0,1.046.826.941.941,0,0,0-1.046-.826m3.993-.471a.943.943,0,1,0,1.045.825.943.943,0,0,0-1.045-.825"
          transform="translate(-146.967 -15.739)"
          fill="#505152"
        />
        <path
          id="Path_21096"
          data-name="Path 21096"
          d="M178.8,77.649a.943.943,0,1,1,.826-1.049.941.941,0,0,1-.826,1.049"
          transform="translate(-143.089 -15.854)"
          fill="#707173"
        />
        <path
          id="Path_21097"
          data-name="Path 21097"
          d="M183.847,78.245a.943.943,0,1,1,.827-1.049.943.943,0,0,1-.827,1.049"
          transform="translate(-152.129 -15.979)"
          fill="#707173"
        />
        <path
          id="Path_21098"
          data-name="Path 21098"
          d="M173.119,77.146a1.369,1.369,0,0,1-1.136-.447,5.083,5.083,0,0,0-.935-.135,5.02,5.02,0,0,0-.9.3A1.378,1.378,0,1,1,170,75.2a5.051,5.051,0,0,0,.935.134,5.233,5.233,0,0,0,.9-.3,1.361,1.361,0,1,1,1.285,2.1m-4.213-1.956a.944.944,0,1,0,1.024.856.944.944,0,0,0-1.024-.856m4.006-.357a.944.944,0,1,0,1.022.855.941.941,0,0,0-1.022-.855"
          transform="translate(-129.814 -15.567)"
          fill="#505152"
        />
        <path
          id="Path_21099"
          data-name="Path 21099"
          d="M169.187,76.828a.944.944,0,1,1,.855-1.026.943.943,0,0,1-.855,1.026"
          transform="translate(-125.922 -15.682)"
          fill="#707173"
        />
        <path
          id="Path_21100"
          data-name="Path 21100"
          d="M174.25,77.279a.944.944,0,1,1,.856-1.024.941.941,0,0,1-.856,1.024"
          transform="translate(-134.99 -15.776)"
          fill="#707173"
        />
        <path
          id="Path_21101"
          data-name="Path 21101"
          d="M163.564,76.192a1.369,1.369,0,0,1-1.145-.422,5.114,5.114,0,0,0-.937-.115,5.17,5.17,0,0,0-.89.318,1.378,1.378,0,1,1-.184-1.654,5.034,5.034,0,0,0,.939.113,5.175,5.175,0,0,0,.888-.315,1.376,1.376,0,1,1,1.329,2.076m-4.253-1.865a.944.944,0,1,0,1.042.833.945.945,0,0,0-1.042-.833m4-.442a.943.943,0,1,0,1.042.833.941.941,0,0,0-1.042-.833"
          transform="translate(-112.661 -15.367)"
          fill="#505152"
        />
        <path
          id="Path_21102"
          data-name="Path 21102"
          d="M159.634,75.875a.943.943,0,1,1,.833-1.042.944.944,0,0,1-.833,1.042"
          transform="translate(-108.779 -15.482)"
          fill="#707173"
        />
        <path
          id="Path_21103"
          data-name="Path 21103"
          d="M164.688,76.435a.944.944,0,1,1,.833-1.044.944.944,0,0,1-.833,1.044"
          transform="translate(-117.83 -15.599)"
          fill="#707173"
        />
        <path
          id="Path_21104"
          data-name="Path 21104"
          d="M153.929,75.425a1.377,1.377,0,0,1-1.124-.478,2.044,2.044,0,0,0-1.833.114,1.378,1.378,0,1,1-.1-1.662,2.061,2.061,0,0,0,1.833-.113,1.375,1.375,0,1,1,1.228,2.139m-4.159-2.069a.944.944,0,1,0,1,.882.944.944,0,0,0-1-.882m4.015-.248a.943.943,0,1,0,1,.882.943.943,0,0,0-1-.882"
          transform="translate(-95.509 -15.207)"
          fill="#505152"
        />
        <path
          id="Path_21105"
          data-name="Path 21105"
          d="M150,75.105a.943.943,0,1,1,.883-1,.943.943,0,0,1-.883,1"
          transform="translate(-91.608 -15.32)"
          fill="#707173"
        />
        <path
          id="Path_21106"
          data-name="Path 21106"
          d="M155.074,75.42a.944.944,0,1,1,.883-1,.942.942,0,0,1-.883,1"
          transform="translate(-100.697 -15.387)"
          fill="#707173"
        />
        <path
          id="Path_21107"
          data-name="Path 21107"
          d="M144.265,75.584a1.37,1.37,0,0,1-1.092-.546,2.063,2.063,0,0,0-1.838,0,1.378,1.378,0,1,1,0-1.664,2.063,2.063,0,0,0,1.838,0,1.375,1.375,0,1,1,1.092,2.209m-4.021-2.322a.944.944,0,1,0,.943.943.944.944,0,0,0-.943-.943m4.021,0a.944.944,0,1,0,.943.943.943.943,0,0,0-.943-.943"
          transform="translate(-78.353 -15.239)"
          fill="#505152"
        />
        <path
          id="Path_21108"
          data-name="Path 21108"
          d="M140.358,75.265a.944.944,0,1,1,.943-.945.942.942,0,0,1-.943.945"
          transform="translate(-74.446 -15.355)"
          fill="#707173"
        />
        <path
          id="Path_21109"
          data-name="Path 21109"
          d="M145.444,75.265a.944.944,0,1,1,.943-.945.943.943,0,0,1-.943.945"
          transform="translate(-83.554 -15.355)"
          fill="#707173"
        />
        <path
          id="Path_21110"
          data-name="Path 21110"
          d="M134.58,75.693a1.373,1.373,0,0,1-1.048-.627,2.051,2.051,0,0,0-1.832-.139,1.377,1.377,0,1,1,.127-1.66,5,5,0,0,0,.9.285,5.09,5.09,0,0,0,.932-.147,1.376,1.376,0,1,1,.923,2.288m-3.835-2.621a.944.944,0,1,0,.87,1.011.944.944,0,0,0-.87-1.011m4.012.305a.944.944,0,1,0,.867,1.011.943.943,0,0,0-.867-1.011"
          transform="translate(-61.205 -15.199)"
          fill="#505152"
        />
        <path
          id="Path_21111"
          data-name="Path 21111"
          d="M130.718,75.455a.944.944,0,1,1,1.01-.871.944.944,0,0,1-1.01.871"
          transform="translate(-57.309 -15.395)"
          fill="#707173"
        />
        <path
          id="Path_21112"
          data-name="Path 21112"
          d="M135.786,75.069A.944.944,0,1,1,136.8,74.2a.944.944,0,0,1-1.012.871"
          transform="translate(-66.388 -15.314)"
          fill="#707173"
        />
        <path
          id="Path_21113"
          data-name="Path 21113"
          d="M124.994,76.6a1.375,1.375,0,0,1-1.045-.633,4.986,4.986,0,0,0-.9-.29,4.921,4.921,0,0,0-.933.142,1.377,1.377,0,1,1,.134-1.659,5.068,5.068,0,0,0,.9.289,5.116,5.116,0,0,0,.935-.142,1.375,1.375,0,1,1,.909,2.292m-3.822-2.639a.944.944,0,1,0,.864,1.015.943.943,0,0,0-.864-1.015m4.008.323a.943.943,0,1,0,.864,1.015.944.944,0,0,0-.864-1.015"
          transform="translate(-44.052 -15.384)"
          fill="#505152"
        />
        <path
          id="Path_21114"
          data-name="Path 21114"
          d="M121.137,76.363a.943.943,0,1,1,1.014-.866.943.943,0,0,1-1.014.866"
          transform="translate(-40.16 -15.585)"
          fill="#707173"
        />
        <path
          id="Path_21115"
          data-name="Path 21115"
          d="M126.2,75.954a.944.944,0,1,1,1.016-.867.947.947,0,0,1-1.016.867"
          transform="translate(-49.233 -15.499)"
          fill="#707173"
        />
        <path
          id="Path_21116"
          data-name="Path 21116"
          d="M115.353,77.546a1.367,1.367,0,0,1-1.017-.674,5.119,5.119,0,0,0-.886-.328,5.03,5.03,0,0,0-.938.1,1.379,1.379,0,1,1,.2-1.652,5.225,5.225,0,0,0,.885.327,5.261,5.261,0,0,0,.939-.1,1.375,1.375,0,1,1,.815,2.326m-3.71-2.794a.944.944,0,1,0,.822,1.052.944.944,0,0,0-.822-1.052m3.993.489a.944.944,0,1,0,.821,1.05.944.944,0,0,0-.821-1.05"
          transform="translate(-26.902 -15.549)"
          fill="#505152"
        />
        <path
          id="Path_21117"
          data-name="Path 21117"
          d="M111.529,77.359a.944.944,0,1,1,1.05-.824.944.944,0,0,1-1.05.824"
          transform="translate(-23.025 -15.794)"
          fill="#707173"
        />
        <path
          id="Path_21118"
          data-name="Path 21118"
          d="M116.572,76.741a.943.943,0,1,1,1.052-.822.942.942,0,0,1-1.052.822"
          transform="translate(-32.061 -15.664)"
          fill="#707173"
        />
        <path
          id="Path_21119"
          data-name="Path 21119"
          d="M105.739,78.472a1.369,1.369,0,0,1-1-.7,4.988,4.988,0,0,0-.878-.347,4.765,4.765,0,0,0-.941.083,1.38,1.38,0,1,1,.24-1.648,5.032,5.032,0,0,0,.879.346,5.153,5.153,0,0,0,.94-.081,1.375,1.375,0,1,1,.762,2.345M102.094,75.6a.944.944,0,1,0,.8,1.068.943.943,0,0,0-.8-1.068m3.98.58a.944.944,0,1,0,.8,1.068.942.942,0,0,0-.8-1.068"
          transform="translate(-9.751 -15.724)"
          fill="#505152"
        />
        <path
          id="Path_21120"
          data-name="Path 21120"
          d="M101.937,78.311a.944.944,0,1,1,1.068-.8.943.943,0,0,1-1.068.8"
          transform="translate(-5.886 -15.994)"
          fill="#707173"
        />
        <path
          id="Path_21121"
          data-name="Path 21121"
          d="M106.967,77.578a.944.944,0,1,1,1.07-.8.944.944,0,0,1-1.07.8"
          transform="translate(-14.896 -15.839)"
          fill="#707173"
        />
        <path
          id="Path_21122"
          data-name="Path 21122"
          d="M96.2,80.235a1.37,1.37,0,0,1-1.018-.673,4.936,4.936,0,0,0-.886-.327,4.8,4.8,0,0,0-.939.1,1.378,1.378,0,1,1,.2-1.653,5.176,5.176,0,0,0,.885.326,5.2,5.2,0,0,0,.939-.1,1.375,1.375,0,1,1,.816,2.326m-3.711-2.791a.943.943,0,1,0,.822,1.05.945.945,0,0,0-.822-1.05m3.992.487a.943.943,0,1,0,.822,1.05.944.944,0,0,0-.822-1.05"
          transform="translate(7.403 -16.112)"
          fill="#505152"
        />
        <path
          id="Path_21123"
          data-name="Path 21123"
          d="M92.372,80.048a.943.943,0,1,1,1.05-.823.942.942,0,0,1-1.05.823"
          transform="translate(11.281 -16.357)"
          fill="#707173"
        />
        <path
          id="Path_21124"
          data-name="Path 21124"
          d="M97.418,79.432a.943.943,0,1,1,1.051-.823.942.942,0,0,1-1.051.823"
          transform="translate(2.243 -16.227)"
          fill="#707173"
        />
        <path
          id="Path_21125"
          data-name="Path 21125"
          d="M84.73,80.128a5.085,5.085,0,0,0-.939.1A1.377,1.377,0,1,1,84,78.575a5.144,5.144,0,0,0,.884.331,5.3,5.3,0,0,0,.939-.1,1.368,1.368,0,0,1,2.339.8l-.436.165a.931.931,0,0,0-.807-.934.935.935,0,0,0-.823,1.551l-.421.159c-.021-.029-.046-.055-.064-.087a4.952,4.952,0,0,0-.884-.333m-1.8-1.8a.943.943,0,1,0,.816,1.054.941.941,0,0,0-.816-1.054"
          transform="translate(24.537 -16.297)"
          fill="#505152"
        />
        <path
          id="Path_21126"
          data-name="Path 21126"
          d="M82,79.9a.943.943,0,0,1,1.056-.814.931.931,0,0,1,.806.934l-1.63.617A.933.933,0,0,1,82,79.9"
          transform="translate(28.408 -16.546)"
          fill="#707173"
        />
        <path
          id="Path_21127"
          data-name="Path 21127"
          d="M87.831,80.312a.943.943,0,1,1,1.056-.816.944.944,0,0,1-1.056.816"
          transform="translate(19.399 -16.412)"
          fill="#707173"
        />
        <path
          id="Path_21128"
          data-name="Path 21128"
          d="M209.039,90.076a4.131,4.131,0,1,1-4.132-4.13,4.131,4.131,0,0,1,4.132,4.13m-6.427,0a2.3,2.3,0,1,0,2.3-2.294,2.3,2.3,0,0,0-2.3,2.294"
          transform="translate(-190.707 -17.984)"
          fill="#707173"
        />
        <path
          id="Path_21129"
          data-name="Path 21129"
          d="M207.69,90.562a2.3,2.3,0,1,1-2.3-2.294,2.3,2.3,0,0,1,2.3,2.294"
          transform="translate(-191.194 -18.47)"
          fill="#505152"
        />
        <path
          id="Path_21130"
          data-name="Path 21130"
          d="M183.375,95.725a1.61,1.61,0,0,0,3.22,0c0-.033-.008-.064-.01-.1h1.687c-.016.013-.032.029-.048.042,0,.021,0,.044,0,.066s0,.045,0,.068c.146.119.336.3.336.414a2.48,2.48,0,0,1-.055.287,2.353,2.353,0,0,1-.074.283c-.051.1-.3.181-.482.224-.02.043-.038.084-.059.124.079.172.174.415.123.518a2.1,2.1,0,0,1-.176.237,2.146,2.146,0,0,1-.191.221c-.088.071-.345.034-.529,0l-.108.082a1.787,1.787,0,0,1-.037.358.31.31,0,0,1-.075.163,2.439,2.439,0,0,1-.259.136,2.033,2.033,0,0,1-.269.118c-.1.023-.27-.084-.411-.188-.022-.017-.046-.033-.066-.049-.044.011-.089.025-.134.034-.084.169-.214.393-.324.417a2.452,2.452,0,0,1-.293.011,2.1,2.1,0,0,1-.292-.011c-.114-.024-.243-.248-.327-.417-.047-.009-.09-.023-.134-.034a2.06,2.06,0,0,1-.249.169.371.371,0,0,1-.229.068,2.084,2.084,0,0,1-.267-.118,2.289,2.289,0,0,1-.259-.136.328.328,0,0,1-.08-.179,1.841,1.841,0,0,1-.032-.342c-.037-.028-.074-.055-.109-.085-.186.041-.44.078-.531.007a2.735,2.735,0,0,1-.191-.224,2.339,2.339,0,0,1-.174-.234c-.051-.1.045-.346.124-.518a1.276,1.276,0,0,1-.059-.124c-.184-.043-.432-.12-.482-.225a2.461,2.461,0,0,1-.076-.282,2.315,2.315,0,0,1-.055-.287c0-.116.191-.294.337-.414a.661.661,0,0,1,0-.068.6.6,0,0,1,0-.066l-.048-.042h1.376c0,.032-.009.063-.009.1"
          transform="translate(-155.16 -20.009)"
          fill="#48494a"
        />
        <path
          id="Path_21131"
          data-name="Path 21131"
          d="M185.813,97.334a1.61,1.61,0,0,1-1.608-1.609c0-.033.008-.064.009-.1h3.2c0,.033.01.064.01.1a1.611,1.611,0,0,1-1.612,1.609"
          transform="translate(-155.989 -20.009)"
          fill="#707173"
        />
        <path
          id="Path_21132"
          data-name="Path 21132"
          d="M165.146,95.725a1.609,1.609,0,1,0,3.218,0c0-.033-.008-.064-.01-.1h1.687l-.047.042c0,.021,0,.044,0,.066s0,.045,0,.068c.145.119.335.3.335.414a2.618,2.618,0,0,1-.054.287,2.172,2.172,0,0,1-.075.283c-.05.1-.3.181-.482.224-.019.043-.037.084-.058.124.08.172.173.415.123.518a2.207,2.207,0,0,1-.176.237,2.26,2.26,0,0,1-.19.221c-.09.071-.346.034-.531,0-.035.028-.071.055-.108.082a1.384,1.384,0,0,1-.06.44.2.2,0,0,1-.052.081,2.436,2.436,0,0,1-.259.136l-.076.036a1.354,1.354,0,0,1-.193.081c-.112.026-.329-.121-.478-.237-.044.011-.089.025-.134.034-.083.169-.213.393-.325.417a2.412,2.412,0,0,1-.293.011h-.033a2,2,0,0,1-.259-.011c-.112-.024-.243-.248-.325-.417-.047-.009-.09-.023-.134-.034a1.049,1.049,0,0,1-.437.233.194.194,0,0,1-.041,0l-.006,0a2.062,2.062,0,0,1-.263-.115,2.408,2.408,0,0,1-.259-.136.186.186,0,0,1-.035-.054,1.156,1.156,0,0,1-.078-.467c-.036-.028-.073-.055-.108-.085-.187.041-.44.078-.531.007a2.549,2.549,0,0,1-.191-.224,2.152,2.152,0,0,1-.172-.234c-.052-.1.044-.346.122-.518-.02-.04-.04-.081-.057-.124-.185-.043-.433-.12-.482-.225a2.431,2.431,0,0,1-.077-.282,2.393,2.393,0,0,1-.053-.287c0-.116.19-.294.335-.414,0-.023,0-.046,0-.068s0-.044,0-.066l-.048-.042h1.378c0,.032-.01.063-.01.1"
          transform="translate(-122.514 -20.009)"
          fill="#48494a"
        />
        <path
          id="Path_21133"
          data-name="Path 21133"
          d="M167.584,97.334a1.61,1.61,0,0,1-1.608-1.609c0-.033.008-.064.01-.1h3.2c0,.033.009.064.009.1a1.61,1.61,0,0,1-1.611,1.609"
          transform="translate(-123.344 -20.009)"
          fill="#707173"
        />
        <path
          id="Path_21134"
          data-name="Path 21134"
          d="M153.751,97.006c-.18-.043-.412-.119-.459-.221a2.189,2.189,0,0,1-.077-.281,2.686,2.686,0,0,1-.054-.287c0-.117.191-.295.337-.414,0-.023,0-.046,0-.068s0-.044,0-.066l-.047-.042h.3Z"
          transform="translate(-97.768 -20.009)"
          fill="#48494a"
        />
        <path
          id="Path_21135"
          data-name="Path 21135"
          d="M151.694,98.085a2.7,2.7,0,0,1-.176.237,2.132,2.132,0,0,1-.191.221c-.089.071-.346.034-.528,0-.036.028-.073.055-.111.082,0,.19-.022.449-.111.521a2.778,2.778,0,0,1-.259.136,2.125,2.125,0,0,1-.27.118c-.111.026-.328-.121-.477-.237-.043.011-.089.025-.134.034-.029.059-.065.123-.1.184-.07.115-.15.217-.223.232a1.334,1.334,0,0,1-.168.009l-.125,0a2.144,2.144,0,0,1-.293-.011c-.068-.015-.144-.108-.211-.215a2.169,2.169,0,0,1-.113-.2c-.047-.009-.091-.023-.134-.034-.15.116-.366.263-.477.237a1.191,1.191,0,0,1-.172-.072l-.1-.046a2.582,2.582,0,0,1-.259-.136c-.089-.072-.111-.331-.111-.521-.037-.028-.075-.055-.109-.085-.186.041-.44.078-.531.007a2.455,2.455,0,0,1-.19-.224,2.042,2.042,0,0,1-.175-.234.631.631,0,0,1,.072-.4l1.276,0h.068l.857,0a1.445,1.445,0,0,0,.876,0l2.534.01a.588.588,0,0,1,.063.376"
          transform="translate(-90.008 -20.441)"
          fill="#48494a"
        />
        <path
          id="Path_21136"
          data-name="Path 21136"
          d="M149.234,97.7l.877,0a1.606,1.606,0,0,1-.433.066,1.582,1.582,0,0,1-.444-.07"
          transform="translate(-91.022 -20.442)"
          fill="#707173"
        />
        <path
          id="Path_21137"
          data-name="Path 21137"
          d="M133.465,98.1a2.838,2.838,0,0,1-.175.237,2.327,2.327,0,0,1-.191.221c-.089.071-.346.034-.529,0-.035.028-.074.055-.109.082,0,.19-.022.449-.111.521a2.674,2.674,0,0,1-.259.136,2.605,2.605,0,0,1-.244.108c-.007,0-.021.009-.026.01-.111.026-.328-.121-.478-.237-.043.011-.089.025-.133.034a2.133,2.133,0,0,1-.138.24c-.061.09-.127.164-.187.176a2.431,2.431,0,0,1-.293.011,2.126,2.126,0,0,1-.293-.011c-.006,0-.013-.009-.019-.012a.776.776,0,0,1-.274-.346c-.01-.02-.022-.04-.031-.059-.047-.009-.091-.023-.134-.034-.151.116-.367.263-.478.237a2.037,2.037,0,0,1-.268-.118,2.4,2.4,0,0,1-.259-.136c-.091-.072-.111-.331-.112-.521-.038-.028-.074-.055-.109-.085-.186.041-.44.078-.53.007a2.291,2.291,0,0,1-.191-.224,2.345,2.345,0,0,1-.174-.234.529.529,0,0,1,.05-.34l2.559.009c.036,0,.071.011.107.011s.066-.008.1-.01l2.886.012a.505.505,0,0,1,.044.318"
          transform="translate(-57.363 -20.455)"
          fill="#48494a"
        />
        <path
          id="Path_21138"
          data-name="Path 21138"
          d="M131.427,97.772h.207c-.033,0-.065.01-.1.01s-.071-.009-.108-.011"
          transform="translate(-58.464 -20.459)"
          fill="#707173"
        />
        <path
          id="Path_21139"
          data-name="Path 21139"
          d="M115.235,98.115a2.9,2.9,0,0,1-.176.237,2.117,2.117,0,0,1-.191.221c-.089.071-.345.034-.528,0l-.109.082c0,.19-.022.449-.113.521-.006,0-.027.015-.039.023-.051.03-.138.074-.219.113a2.034,2.034,0,0,1-.27.118c-.111.026-.329-.121-.478-.237-.043.011-.089.025-.133.034-.085.169-.214.393-.326.417a2.437,2.437,0,0,1-.293.011,2.128,2.128,0,0,1-.293-.011A.185.185,0,0,1,112,99.6a1.191,1.191,0,0,1-.259-.378c-.047-.009-.091-.023-.137-.034-.149.116-.365.263-.477.237a2.035,2.035,0,0,1-.268-.118,2.306,2.306,0,0,1-.258-.136c-.092-.072-.111-.331-.112-.521-.038-.028-.074-.055-.108-.085-.187.041-.441.078-.531.007a2.407,2.407,0,0,1-.191-.224,2.524,2.524,0,0,1-.175-.234.444.444,0,0,1,.031-.283l5.693.023a.412.412,0,0,1,.024.26"
          transform="translate(-24.718 -20.472)"
          fill="#48494a"
        />
        <path
          id="Path_21140"
          data-name="Path 21140"
          d="M111.477,86.929l-6.1-.012-.43-.705h38.543v.779L111.9,86.929h-.421Z"
          transform="translate(-49.375 -18.039)"
          fill="#505152"
        />
        <path
          id="Path_21141"
          data-name="Path 21141"
          d="M183.988,93.658H153.142V86.211h30.109l-.319,7.364h1.056L184,86.917Z"
          transform="translate(-128.002 -18.039)"
          fill="#505152"
        />
        <path
          id="Path_21142"
          data-name="Path 21142"
          d="M85.64,83.317s-.047-1.665,1.377-1.665h13.888l-2.092.788H87.839c-1.3,0-1.263,1.476-1.263,1.476v.3h4.177a15.894,15.894,0,0,0-2.072,1.2H86.576v.62l-.936,0V83.317Z"
          transform="translate(8.472 -17.085)"
          fill="#666769"
        />
        <path
          id="Path_21143"
          data-name="Path 21143"
          d="M76.62,83.866v-.015l.691-.307c.007.1.008.169.008.169v.573l-.7-.372v-.048"
          transform="translate(39.191 -17.481)"
          fill="#666769"
        />
        <path
          id="Path_21144"
          data-name="Path 21144"
          d="M97.7,98.912H78.055a1.265,1.265,0,0,1-1.284-1.032l1.351.006a1.179,1.179,0,0,0,.756.239h18a1.2,1.2,0,0,0,.615-.161l1.464.006a1.243,1.243,0,0,1-1.257.943"
          transform="translate(17.434 -20.481)"
          fill="#666769"
        />
        <path
          id="Path_21145"
          data-name="Path 21145"
          d="M88.286,84.126s-.042-1.476,1.262-1.476h10.974c-2.266.853-4.024,1.514-4.5,1.691h0c-.089.032-.139.052-.139.052l-.032-.23L95.7,83.009s-1.632.625-3.234,1.422H88.286Z"
          transform="translate(6.762 -17.294)"
          fill="#505152"
        />
        <path
          id="Path_21146"
          data-name="Path 21146"
          d="M93.954,98.125H79.379a1.176,1.176,0,0,1-.755-.239l19.37.078a1.2,1.2,0,0,1-.614.161Z"
          transform="translate(16.931 -20.481)"
          fill="#505152"
        />
        <path
          id="Path_21147"
          data-name="Path 21147"
          d="M103.2,86.414a4.173,4.173,0,0,0-.723.623l-1.382,0v-.621Z"
          transform="translate(-6.049 -18.083)"
          fill="#505152"
        />
        <path
          id="Path_21148"
          data-name="Path 21148"
          d="M56.832,74.213l2.511,6.326-2.478.984L54.951,76.7,56,76.238l-.231-.519,1.2-.532L55.511,71.9l-1.2.532-.23-.52-.875.389-1.12-2.819,2.478-.984,1.5,3.789,7.737-3.437.838,1.886Z"
          transform="translate(71.266 -14.334)"
          fill="#d4d4d4"
        />
        <path
          id="Path_21149"
          data-name="Path 21149"
          d="M51.839,69.289c.134.107.44.406.826.8l-1.706.755-.169-.38-.838-1.887-.236-.531,1.984-.884-.066.3s-.389,1.356.206,1.832"
          transform="translate(85.12 -14.052)"
          fill="#3b3c3d"
        />
        <path
          id="Path_21150"
          data-name="Path 21150"
          d="M68.662,74.225l2.292-1.018.875-.389.231.519,1.2-.532,1.457,3.283-1.2.531.231.52L72.7,77.6l-2.118.941-.231-.52-3.424,1.521-2.788,1.238a10.034,10.034,0,0,1,1.122,2.463l-2.268-1.208v-.573s0-.073-.008-.17l-.691.307v-.146c0-.054,0-.115,0-.187v-.006c0-.074,0-.153,0-.241h0c-.006-.233-.017-.512-.036-.808h0c0-.011,0-.022,0-.033-.008-.125-.017-.251-.028-.379l-.009-.1c-.012-.127-.025-.253-.04-.379l-.007-.062a3.686,3.686,0,0,0-.369-1.369l3.968-1.762,3.13-1.39Z"
          transform="translate(53.518 -15.235)"
          fill="#3b3c3d"
        />
        <path
          id="Path_21151"
          data-name="Path 21151"
          d="M103.294,94.877l-1.465-.006-19.37-.078-1.351,0L77.4,94.773,71.7,94.75l-8.742-.035L60.075,94.7h-.207l-2.56-.01-8.781-.036-2.534-.009-.877,0-.857,0h.833L45.1,86.9l4.328-.622,31.589.061.936,0,1.382,0a4.135,4.135,0,0,1,.723-.623,16,16,0,0,1,2.072-1.2c1.6-.8,3.233-1.422,3.233-1.422l.161,1.153-5.142,1.817-.6.272,14.484.029h0l-14.926-.029s-.1.815.439.9l12.6-.452-20.6,4.569-22.735.418s.054.768,1.358,1.026,22.026-.138,22.026-.138l27.7-6.153,3.419-.123,0,0,3.194.006,2.452.006.822-.947h5.461l.96.96,8.557.017.019.217-3.991,1.462-2.349,1.252.092,3.519,3.572,2.088L107.964,94.9l-3.928-.016Z"
          transform="translate(13.096 -17.388)"
          fill="#616263"
        />
        <path
          id="Path_21152"
          data-name="Path 21152"
          d="M150.805,87.115h-4.076v8.362l-1.275,0h-.028v-.249l0-1.378.013-6.741,6.1.012Z"
          transform="translate(-89.442 -18.225)"
          fill="#616263"
        />
        <path
          id="Path_21153"
          data-name="Path 21153"
          d="M72.745,86.375l8.5-2.11-.474-.252.7.372,2.268,1.208.8.423Z"
          transform="translate(35.036 -17.58)"
          fill="#616263"
        />
        <path
          id="Path_21154"
          data-name="Path 21154"
          d="M77.5,83.95v0Z"
          transform="translate(38.307 -17.565)"
          fill="#616263"
        />
        <path
          id="Path_21155"
          data-name="Path 21155"
          d="M77.56,81.657c.011.128.021.254.028.379-.008-.124-.017-.251-.028-.379"
          transform="translate(38.179 -17.087)"
          fill="#616263"
        />
        <path
          id="Path_21156"
          data-name="Path 21156"
          d="M77.647,81.43c-.012-.127-.025-.254-.04-.379.015.126.028.251.04.379"
          transform="translate(38.082 -16.96)"
          fill="#616263"
        />
        <path
          id="Path_21157"
          data-name="Path 21157"
          d="M94.782,80.555a6.485,6.485,0,0,0-.156-.84s-10.452,3.857-10.452,4.151,3.013-.945,5.849-1.3a39.987,39.987,0,0,0,4.846-1.06c.018.3.029.575.035.807L84.158,85.47l-6.645-.26,4.218-1.419.16-.219c.471-.176,2.23-.837,4.5-1.69l2.092-.789.837-.316.421-.159L91.366,80l.436-.165,1.92-.729L94.009,79c.163-.062.295.021.4.19a3.694,3.694,0,0,1,.368,1.369"
          transform="translate(20.899 -16.526)"
          fill="#616263"
        />
        <path
          id="Path_21158"
          data-name="Path 21158"
          d="M77.507,83.51v0"
          transform="translate(38.302 -17.473)"
          fill="#616263"
        />
        <path
          id="Path_21159"
          data-name="Path 21159"
          d="M77.5,83.774v0"
          transform="translate(38.307 -17.525)"
          fill="#616263"
        />
        <path
          id="Path_21160"
          data-name="Path 21160"
          d="M71.4,87.256h0l2.842.006Z"
          transform="translate(46.398 -18.258)"
          fill="#616263"
        />
        <path
          id="Path_21161"
          data-name="Path 21161"
          d="M41.62,90.3l2.349-1.252,3.991-1.462.034.382-4.532,3.038-.027,3.16,2.418,1.023,3.433.129.761.607-4.764-.019L41.711,93.82Z"
          transform="translate(94.14 -18.327)"
          fill="#4b4c4d"
        />
        <path
          id="Path_21162"
          data-name="Path 21162"
          d="M46.5,78.5,35.231,88.248l.368.775-3.433-.129-2.417-1.022.027-3.16,4.531-3.038-.033-.383-.019-.217-.824-9.364c-.58-.62-2.371-2.527-3.473-3.645-.386-.391-.692-.691-.826-.8-.595-.476-.206-1.832-.206-1.832l.066-.3.345-1.551,3.195-2.1-.352-3.994,12,2.613ZM32.748,82.717l-.1.068.148.314Zm.324,1.912a1.565,1.565,0,1,0,1.565,1.565,1.566,1.566,0,0,0-1.565-1.565M31.621,64.284a1.565,1.565,0,1,0,1.565,1.566,1.566,1.566,0,0,0-1.565-1.566"
          transform="translate(107.829 -12.031)"
          fill="#ffb800"
        />
        <path
          id="Path_21163"
          data-name="Path 21163"
          d="M4.128,86.087,18.88,76.5,15.572,55.7.462,51.745,0,43.46,2.46,44.683l3.434,3.764,10.2,2.387,3.124.306L29.23,83.549l2.961-.332s4.57,4.827,5.352,5.957a1.036,1.036,0,0,1-.471,1.646L22.4,87.783l.487-.61-.541-.106,3.907-3.907-8.66-30.871,6.393,30.019-4.249,4.249.177.035-3.438-.672L5.466,87.154l-.577-.46Z"
          transform="translate(139.299 -9.094)"
          fill="#ffb800"
        />
        <path
          id="Path_21164"
          data-name="Path 21164"
          d="M45.361,94.939a1.565,1.565,0,1,1,1.565-1.565,1.564,1.564,0,0,1-1.565,1.565"
          transform="translate(95.54 -19.21)"
          fill="#4b4c4d"
        />
        <path
          id="Path_21165"
          data-name="Path 21165"
          d="M73.054,46.652a1.565,1.565,0,1,1-1.565,1.566,1.566,1.566,0,0,1,1.565-1.566"
          transform="translate(45.948 -9.762)"
          fill="#4b4c4d"
        />
        <path
          id="Path_21166"
          data-name="Path 21166"
          d="M47.2,69.211a1.565,1.565,0,1,1,1.565-1.565A1.564,1.564,0,0,1,47.2,69.211"
          transform="translate(92.253 -13.826)"
          fill="#4b4c4d"
        />
        <path
          id="Path_21167"
          data-name="Path 21167"
          d="M77.176,84.507s.051-.021.139-.053h0l-.16.219-4.218,1.419,6.645.26L90.328,83.2c0,.088,0,.168,0,.241v.006c0,.071,0,.132,0,.187v.209l.474.252-8.5,2.11L94.1,85.846h0l1.06.565,0,0-2.842-.006h0l-6.442-.012h0L71.4,86.365l.6-.272,5.142-1.816Z"
          transform="translate(25.476 -17.41)"
          fill="#4b4c4d"
        />
        <path
          id="Path_21168"
          data-name="Path 21168"
          d="M83.407,82.763c-2.836.354-5.849,1.594-5.849,1.3s10.451-4.151,10.451-4.151a6.488,6.488,0,0,1,.156.84c0,.021,0,.041.008.062.015.125.028.251.04.379,0,.033.006.066.009.1.011.128.021.255.028.379,0,.011,0,.023,0,.034a40.135,40.135,0,0,1-4.846,1.06"
          transform="translate(27.516 -16.722)"
          fill="#707173"
        />
        <path
          id="Path_21169"
          data-name="Path 21169"
          d="M42.344,78.688l-14.752,9.59-.368-.776L38.49,77.757,36.173,59.364l-12-2.613h0l-.247-2.814,15.11,3.959Z"
          transform="translate(115.834 -11.287)"
          fill="#db9e00"
        />
        <path
          id="Path_21170"
          data-name="Path 21170"
          d="M46.228,89.392l.047.382-.148-.314Z"
          transform="translate(94.348 -18.705)"
          fill="#db9e00"
        />
        <path
          id="Path_21171"
          data-name="Path 21171"
          d="M20.994,84.644,14.6,54.625,23.263,85.5,19.356,89.4l-2.433-.476-.176-.035Z"
          transform="translate(142.289 -11.431)"
          fill="#db9e00"
        />
        <path
          id="Path_21172"
          data-name="Path 21172"
          d="M144.888,95.48V87.118h5.236l-4.328.622-.006,7.739h-.9Z"
          transform="translate(-87.602 -18.228)"
          fill="#707173"
        />
        <path
          id="Path_21173"
          data-name="Path 21173"
          d="M123.066,87.244h0l2.843.006-3.419.123-27.7,6.154s-20.724.4-22.026.137S71.4,92.638,71.4,92.638l22.736-.418,20.6-4.569-12.6.452c-.543-.083-.44-.9-.44-.9l14.927.028h0Z"
          transform="translate(-5.264 -18.246)"
          fill="#707173"
        />
        <path
          id="Path_21174"
          data-name="Path 21174"
          d="M146.556,1.122c0,.544.153,4.234-.272,4.66-.307.306-1.71.242-2.468.182L146.228.8c.184.05.328.144.328.327"
          transform="translate(-83.209 -0.167)"
          fill="#d4d4d4"
        />
        <path
          id="Path_21175"
          data-name="Path 21175"
          d="M147.6,6.738h0l.228.462c-.239-.02-.394-.037-.394-.037Z"
          transform="translate(-87.322 -1.411)"
          fill="#d4d4d4"
        />
        <path
          id="Path_21176"
          data-name="Path 21176"
          d="M143.894.509,149.3,0l-.293.629L146.6,5.8l-.045.1L146.5,5.79l-.229-.462Z"
          transform="translate(-85.989 0)"
          fill="#ffb800"
        />
      </g>
    </svg>
  );
};

export default BulldozerSelected;
